<template>
    <div class="comRelBox">
        <div class="searchMain"> 
            <div class="row1">
                <div class="itemWrap" style="width:100%">
                    <label style="margin-right:1rem;">行政區</label>
                    <DistSelection  v-model="selectedAreaValue"  width="15%"  @area-change="handleAreaChange" />
                    <el-input v-model="keyword" placeholder="公司名稱 / 統一編號 / 關鍵詞" style="width:25%;margin-right:15px;" clearable @clear="handleClearInput"></el-input>                    
                    <el-button style="margin-right: 20px;" type="primary" icon="el-icon-search" @click="doSearch">查詢</el-button>                    
                    <a href="#" v-if="btnHotTag" style="margin-right: 20px;" @click="showTagCloud = true"><i style="margin-right: 5px;" class="el-icon-price-tag" ></i>熱門標籤</a>
                    <a href="#" style="margin-right: 20px;" @click="doClearTags"><i style="margin-right: 5px;" class="el-icon-delete"></i>清空條件</a>   
                    <a href="#" v-if="btnAdvFuncVisible" style="margin-right: 20px;" @click="handleSaveSearch"><i style="margin-right: 5px;" class="el-icon-news"></i>儲存搜尋條件</a>
                    <a href="#" v-if="btnAdvFuncVisible" style="margin-right: 20px;" @click="showLoadSearch=true"><i style="margin-right: 5px;" class="el-icon-present"></i>載入搜尋條件</a>
                </div>
            </div>
            <div class="rowtag" v-if="lstQuery.length > 0">
                <label style="margin-right: 1rem;">已選條件</label>
                <el-tag v-for="tag in lstQuery" :key="tag"  type="success" closable :disable-transitions="false" @close="handleClose(tag)">
                {{tag}}
                </el-tag>
            </div>
        </div>
        <div class="searchWrap" style="flex-direction: column;">
            <div class="row1">
                <label style="margin-right: 30px;">篩選條件</label>
                <div class="itemWrap">                    
                    <el-dropdown placement="bottom-start" @command="comStatusChangeHandler" trigger="click">
                        <span class="el-dropdown-link">
                            公司狀況<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="全部">全部</el-dropdown-item>
                            <el-dropdown-item command="營業中">營業中</el-dropdown-item>
                            <el-dropdown-item command="非營業中">非營業中</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="itemWrap">                    
                    <el-dropdown placement="bottom-start" @command="comTypeChangeHandler" trigger="click">
                        <span class="el-dropdown-link">
                            公司類別<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="全部">全部</el-dropdown-item>
                            <el-dropdown-item v-for="item in ComTypeList" :key="item.comType" :command="item.comType">
                                {{ item.comType }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>                    
                <div class="itemWrap">                    
                    <el-dropdown placement="bottom-start" @command="orgTypeChangeHandler" trigger="click">
                        <span class="el-dropdown-link">
                            組織別<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="全部">全部</el-dropdown-item>
                            <el-dropdown-item v-for="item in OrgTypeList" :key="item.comType" :command="item.comType">
                                {{ item.comType }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>            
                <div class="itemWrap">
                    <el-checkbox v-model="IsCustomer"  @change="otherChangeHandler('既有客戶')">
                        <label style="font-size: 13px;">既有客戶</label>
                    </el-checkbox>         
                </div>         
                <div class="itemWrap">
                    <el-checkbox v-model="IsInvoice"  @change="otherChangeHandler('有發票')">
                        <label style="font-size: 13px;">有發票</label>
                    </el-checkbox>         
                </div>                          
                <div class="itemWrap">
                    <el-checkbox v-model="IsImport"  @change="otherChangeHandler('有進口')">
                        <label style="font-size: 13px;">有進口</label>
                    </el-checkbox>         
                </div>         
                <div class="itemWrap">
                    <el-checkbox v-model="IsExport"  @change="otherChangeHandler('有出口')">
                        <label style="font-size: 13px;">有出口</label>
                    </el-checkbox>                  
                </div>
                <div class="itemWrap">
                    <el-checkbox v-model="IsFactory"  @change="otherChangeHandler('有工廠')">
                        <label style="font-size: 13px;">有工廠</label>
                    </el-checkbox>           
                </div>
            </div> 
        </div>
        <div class="searchWrap" style="margin-bottom: 10px;">
            <div class="row1">
                <label style="margin-right: 30px;">進階條件</label>
                <!-- 資本額 -->
                 <div class="itemWrap">
                    <el-dropdown placement="bottom-start" @command="radClick" trigger="click"> 
                        <span class="el-dropdown-link">
                            實收資本<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-money" v-for="c in capList" :command="c.value" :key="c.value" >
                            {{c.cap}}
                            </el-dropdown-item>
                            <el-dropdown-item icon="el-icon-edit" command="custom">
                            自訂區間
                            </el-dropdown-item>                                                
                        </el-dropdown-menu>
                    </el-dropdown>
                 </div>
                

                <!-- 公司設立日期 -->
                 <div class="itemWrap">
                    <el-dropdown placement="bottom-start" @command="yearClick" trigger="click"> 
                    <span class="el-dropdown-link">
                        設立年數<i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item icon="el-icon-date" v-for="c in yearList" :command="c.value" :key="c.value" >
                        {{c.cap}}
                        </el-dropdown-item>
                        <el-dropdown-item icon="el-icon-edit" command="custom">
                        自訂區間
                        </el-dropdown-item>                                                
                    </el-dropdown-menu>
                    </el-dropdown>
                </div> 

                <!-- 行業代號下拉選單 -->                
                <div class="itemWrap">
                    <IndusCodeSelection size="small"
                        v-model="selectedIndustryCode"
                        @change="handleIndustryCodeChange"
                    /> 

                </div>
            </div>
        </div>

        <div class="searchWrap" style="margin-top:-50px;">
            <div class="row3"  >
                <el-button v-if="btnAdvFuncVisible" type="danger" @click="addCustomer" icon="el-icon-plus">新增潛在客戶</el-button>          
                <el-button v-if="btnAdvFuncVisible" type="success" @click="doTags" icon="el-icon-plus">新增企業標籤</el-button>          
            </div>            
        </div>        
        
        <div class="content" style="margin-top:20px;">
            <el-table ref="multipleTable" :row-key="getRowKey" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="tableData" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="50" :reserve-selection="true" ></el-table-column>
                <el-table-column label="統編"  prop="UniComNm" min-width="8%">
                    <template slot-scope="scope">     
                        <el-tooltip content="將開啟新頁" placement="top">                             
                        <a class="goDetailPage" @click="doShowCompanyDetail(scope.row)">{{ scope.row.UniComNm }}</a>
                        </el-tooltip>
                    </template>                
                </el-table-column>   
                <el-table-column label="公司名稱"  prop="ComName" min-width="22%">
                    <template slot-scope="scope">                                                          
                        <el-tooltip content="將開啟新頁" placement="top">
                        <a class="goDetailPage" @click="doshowDetail(scope.row)">{{ scope.row.ComName }}</a>
                        </el-tooltip>
                        <br/>                                                
                        <el-tag v-for="tag in scope.row.tags_array" :key="tag" type="success" size="small" class="tagsClass">
                            {{ tag }}
                        </el-tag>
                    </template>
                </el-table-column>                              
                <el-table-column label="資本額"  prop="Cap" min-width="10%" align="right"  >
                    <template slot-scope="scope">
                        {{ formatCapital(scope.row.Cap) }}
                    </template> 
                </el-table-column>
                <el-table-column label="成立時間"  prop="ApvDt" min-width="10%">                
                    <template slot-scope="scope">
                        <!-- {{ formatDate(scope.row._source.tx_SetupDate) }} -->
                        {{ scope.row.ApvDt }}
                        
                    </template> 
                </el-table-column>              
                <el-table-column label="地址" prop="ComLoc"  min-width="30%">  
                    <!-- <template slot-scope="scope">                        
                        <el-tooltip effect="dark" :content="scope.row.ComLoc" placement="right">
                            <span>{{ formatAddressBrief(scope.row.ComLoc) }}</span>                             
                        </el-tooltip>  
                    </template>                   -->
                </el-table-column>
                <el-table-column label="企業資訊"  min-width="20%">
                    <template slot-scope="scope">                        
                        <el-button icon="el-icon-map-location" size="small" type="text" @click="doshowMap(scope.row)" >地圖</el-button>                        
                        <el-tooltip content="將開啟新頁" placement="top">                             
                        <el-button icon="el-icon-school" size="small" type="text" @click="doShowSimilarCompany(scope.row)" >相似企業</el-button>                                                                                          
                        </el-tooltip>
                        <el-tooltip content="將開啟新頁" placement="top">                             
                        <el-button icon="el-icon-tickets"  size="small" type="text" @click="openTagDrawer(scope.row)"  >標籤資訊</el-button>                        
                        </el-tooltip>
                    </template>
                </el-table-column>

            </el-table>            
        </div>
        <div class="pageBox">
            <Pagination
                @currentChange="pageChange"
                :pageSize="this.listQuery.Page_Size"
                :propsCurrentPage="this.listQuery.Page_Num"
                :totalLists="totalLists"
                :maxPageLimit="50">
            </Pagination>
        </div> 

        <!-- 新增標籤對話框 可勾選多家公司-->
        <el-dialog title="新增標籤" :visible.sync="showTag" width="30%" center>
        <div class="tag-form">
            <!-- 顯示公司名稱 -->
            <div class="form-item">
                <label>公司名稱</label>
                <div class="company-name">{{ getSelectedComNames() }}</div>
            </div>
            <!-- 標籤輸入框 , 如果 RoleName 是 HE, HD, HC, HC1  時, 才會顯示出來-->
            <div class="form-item" v-if="newTagFormType=='hq'"> 
                <label>標籤類型</label>
                <el-radio-group v-model="newTagFormTypeMulti" style="display: inline-flex; gap: 10px;">
                    <el-radio label="hq" >總行標籤</el-radio>
                    <el-radio label="br">自訂標籤</el-radio>
                </el-radio-group>
            </div>        
            
            <!-- 標籤輸入框 -->
            <div class="form-item">
                <label>標籤內容(可輸入多個標籤用逗號, 隔開)</label>
                <el-input v-model="newTagForm.content" placeholder="請輸入標籤內容"></el-input>
            </div>
        </div>
        
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveNewTag()" icon="el-icon-plus" >儲存</el-button>
            <el-button @click="showTag = false" icon="el-icon-close">取消</el-button>        
        </span>
        </el-dialog>        
        
        <!-- 左側標籤抽屜 -->
        <el-drawer
            :title="selectedCompanyTags.company ? selectedCompanyTags.company.ComName + ' 標籤資訊' : '標籤資訊'"
            :visible.sync="tagDrawerVisible"
            direction="ltr"
            :size="tagDrawerWidth"
            :with-header="true"
            :show-close="true"
            :close-on-click-modal="true"
            :close-on-press-escape="true"
            :modal="false"
        >
            <div class="tag-drawer-content" v-if="selectedCompanyTags.company">
                
                <!-- 總行標籤區域 -->
                <div class="tags-section" v-if="splitHqTags && splitHqTags.length > 0">
                    <h3 class="section-title">
                        <i class="el-icon-collection-tag"></i>
                        總行標籤 ({{ splitHqTags.length }})
                    </h3>
                    <div class="tags-container">
                        <el-tag
                            v-for="(tag, index) in splitHqTags"
                            :key="`hq-${index}`"
                            type="success"
                            size="small"
                            class="tag-item"
                        >
                            <a href="javascript:void(0)" @click="handleTagClick(tag.name, tag.category || '', '總行標籤')" style="color: #67c23a; text-decoration: none;">{{ tag.name }}</a>
                        </el-tag>
                    </div>
                </div>
                
                <!-- 自訂標籤區域 -->
                <div class="tags-section" v-if="splitBrTags && splitBrTags.length > 0">
                    <h3 class="section-title">
                        <i class="el-icon-collection"></i>
                        自訂標籤 ({{ splitBrTags.length }})
                    </h3>
                    <div class="tags-container">
                        <el-tag
                            v-for="(tag, index) in splitBrTags"
                            :key="`br-${index}`"
                            type="success"
                            size="small"
                            class="tag-item"
                        >
                            <a href="javascript:void(0)" @click="handleTagClick(tag.name, tag.category || '', '自訂標籤')" style="color: #67c23a; text-decoration: none;">{{ tag.name }}</a>
                        </el-tag>
                    </div>
                </div>
                
                <!-- 標準標籤區域 -->
                <div class="tags-section" v-if="splitStdTags && splitStdTags.length > 0">
                    <h3 class="section-title">
                        <i class="el-icon-collection-tag"></i>
                        標準標籤 ({{ splitStdTags.length }})
                    </h3>
                    <div class="tags-container">
                        <el-tag
                            v-for="(tag, index) in splitStdTags"
                            :key="`std-${index}`"
                            type="success"
                            size="small"
                            class="tag-item"
                        >
                            <a
                                v-if="tag.isHyperLink"
                                href="javascript:void(0)"
                                @click="handleTagClick(tag.name, tag.category || '', '標準標籤')"
                                style="color: #67c23a; text-decoration: none;"
                            >{{ tag.name }}</a>
                            <span v-else>{{ tag.name }}</span>
                        </el-tag>
                    </div>
                </div>
                
                <!-- 當沒有任何標籤時的提示 -->
                <div v-if="(!splitBrTags || splitBrTags.length === 0) && (!splitHqTags || splitHqTags.length === 0)" class="no-tags-message">
                    <el-empty description="此公司暫無標籤資訊">
                        <i class="el-icon-collection-tag" style="font-size: 64px; color: #ddd;"></i>
                    </el-empty>
                </div>
                
                <!-- 操作按鈕區域 -->
                <div class="tag-actions" v-if="btnAdvFuncVisible">
                    <el-button type="primary" icon="el-icon-plus" size="small" @click="openAddTagDialog">
                        新增標籤
                    </el-button>
                </div>
            </div>
        </el-drawer>
        
        <!-- 新增標籤對話框 -->
        <el-dialog title="新增標籤" :visible.sync="showAddTagDialog" width="30%" center>
            <div class="tag-form">
                <!-- 顯示公司名稱 -->
                <div class="form-item">
                    <label>公司名稱</label>
                    <div class="company-name">{{ selectedCompanyTags.company ? selectedCompanyTags.company.ComName : '請先選擇公司' }}</div>
                </div>
                <!-- 標籤類型選擇，如果 RoleName 是 HE, HD, HC, HC1 時，才會顯示出來-->
                <div class="form-item" v-if="newTagFormType=='hq'"> 
                    <label>標籤類型</label>
                    <el-radio-group v-model="selectedCompanyTags.type" style="display: inline-flex; gap: 10px;">
                        <el-radio label="hq" >總行標籤</el-radio>
                        <el-radio label="br">自訂標籤</el-radio>
                    </el-radio-group>
                </div>        
                
                <!-- 標籤輸入框 -->
                <div class="form-item">
                    <label>標籤內容(可輸入多個標籤用逗號, 隔開)</label>
                    <el-input v-model="newTagForm.content" placeholder="請輸入標籤內容"></el-input>
                </div>
            </div>
            
            <span slot="footer" class="dialog-footer">
                <el-button v-if="btnAdvFuncVisible" type="primary" @click="saveNewTagFromDrawer">儲存</el-button>
                <el-button @click="showAddTagDialog = false">取消</el-button>        
            </span>
        </el-dialog>

        <el-dialog title="熱門標籤" :visible.sync="showTagCloud" width="60%" center>
            <div class="dialogBox" >
                <div style="text-align: center;color: #FF0000; margin-bottom: 20px;">
                    <h2>請點選以下的文字</h2>
                </div>
                <div style="cursor: pointer;">
                    <wordcloud
                        :data="hotTagsList"
                        nameKey="TagName"
                        valueKey="Weight"
                        :rotate="rotateText"
                        :color="myColors"
                        :showTooltip="false"
                        :wordClick="wordClickHandler"
                        :fontSize="[35, 50]"
                        :fontSizeRatio="1.2"
                        :padding="50">
                    </wordcloud>
                </div>

            </div>
          <span slot="footer" class="dialog-footer">                
                <el-button type="danger"  @click="showTagCloud=false" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
          </span>
        </el-dialog>          
        

        <el-dialog title="新增潛在客戶" :visible.sync="showPotCustomer" width="40%" center>
            <div class="dialogBox" >
                <div class="projMaintain__searchBox--sort">
                    <h2>公司名稱 : {{ checkedCompanies}} </h2>                    
                </div>
                <hr/>
                <div class="projMaintain__searchBox--sort">
                    <label>專案名稱：</label>
                    <el-select v-model="selectedProjectName" placeholder="請選擇分類" no-data-text="無數據" @change="getDeptList">
                        <el-option label="請選擇" value=""></el-option>
                        <el-option :label="item.ProjectName" :value="item.ID" v-for="item in ProjectNameList" :key="item.ID"></el-option>
                    </el-select>
                    <el-dropdown trigger="click" style="margin-left: 20px;" @command="handleProjectName">
                        <el-button type="primary">
                            <font-awesome-icon icon="cog" style="margin: auto 10px;" />操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="add">
                                <font-awesome-icon icon="plus" style="margin-right:8px;" />新增專案名稱
                            </el-dropdown-item>
                            <el-dropdown-item command="edit">
                                <font-awesome-icon icon="edit" style="margin-right:8px;" />修改專案名稱
                            </el-dropdown-item>
                            <el-dropdown-item command="delete">
                                <font-awesome-icon icon="trash" style="margin-right:8px;" />刪除專案名稱
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>                
                </div>

                <!-- 加入潛在客戶的原因 -->
                <!-- <div class="projMaintain__searchBox--theme" style="margin-top:20px;">
                    <label>備註：</label>
                    <el-input type="textarea" rows="2" v-model="reasonDesc"  placeholder="簡明描述推薦加入潛在客戶的原因" style="width:100%;margin-right:15px;margin-top:15px" clearable></el-input>                                       
                </div>                 -->
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary"  @click="saveCustomer()" ><font-awesome-icon icon="plus"  style="margin-right:5px;" />新增</el-button>
                    <el-button type="danger"  @click="showPotCustomer=false" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
            </span>
        </el-dialog>         
        
        <el-dialog title="儲存搜尋條件" :visible.sync="showSaveSearch" width="50%" center>
            <div class="dialogBox" >
                <div style="margin: 5px 5px">
                    <label>條件名稱：</label> <el-input v-model="ssName" placeholder="輸入儲存條件的名稱" style="width:35%;margin-right:15px;" clearable maxlength="100" show-word-limit></el-input>                    
                </div>                
                <div style="margin: 5px 5px">
                    <label>查詢條件：</label>
                    <el-tag :key="tag" class="tagsClass" v-for="tag in lstQuery" type="success" closable :disable-transitions="false" @close="handleClose(tag)">
                        {{tag}}
                    </el-tag>
                </div>
                <!-- 加入潛在客戶的原因 -->
                <div style="margin: 5px 5px;">
                    <label>條件備註：</label>
                    <el-input type="textarea" rows="2" v-model="ssDesc"  placeholder="簡明描述儲存此查詢條件的原因" style="width:100%;margin-right:15px;margin-top:15px" clearable maxlength="100" show-word-limit></el-input>                    
                </div>                
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary"  @click="saveSearch()" ><font-awesome-icon icon="plus"  style="margin-right:5px;" />新增</el-button>
                    <el-button type="danger"  @click="showSaveSearch=false" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
            </span>
        </el-dialog>           


        <el-dialog title="載入搜尋條件" :visible.sync="showLoadSearch" width="50%" center>
            <div class="dialogBox" >
                <div style="margin: 5px 5px">
                    <label>條件名稱：</label> 
                    <el-select v-model="selSaveSearch" placeholder="請選擇分類" no-data-text="無數據" @change="changeSaveSearch">
                        <el-option label="請選擇" value=""></el-option>
                        <el-option :label="item.name" :value="item.name" v-for="item in saveSearchList" :key="item.ID"></el-option>
                    </el-select>
                </div>                
                <div style="margin: 5px 5px">
                    <label>查詢條件：</label>
                    <el-tag :key="tag" class="tagsClass" v-for="tag in lstLoadQuery" type="success" closable :disable-transitions="false" @close="handleClose(tag)">
                        {{tag}}
                    </el-tag>
                </div>
                <!-- 加入潛在客戶的原因 -->
                <div style="margin: 5px 5px;">
                    <label>條件備註：</label>
                    <el-input type="textarea" rows="2" v-model="lssDesc"  placeholder="簡明描述儲存此查詢條件的原因" style="width:100%;margin-right:15px;margin-top:15px" clearable></el-input>                    
                </div>                
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary"  @click="loadSaveSearch()" ><font-awesome-icon icon="plus"  style="margin-right:5px;" />載入</el-button>
                    <el-button type="danger"  @click="showLoadSearch=false" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
            </span>
        </el-dialog>

        <!-- 自訂資本額區間對話框 -->
        <el-dialog title="自訂資本額區間" :visible.sync="showCustomCapital" width="40%" center>
            <div class="dialogBox">
                <el-form label-width="100px">
                    <el-form-item label="起始金額">
                        <el-input v-model="customCapital.start" placeholder="請輸入起始金額（萬元）" type="number">
                            <template slot="append">萬元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="結束金額">
                        <el-input v-model="customCapital.end" placeholder="請輸入結束金額（萬元）" type="number">
                            <template slot="append">萬元</template>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmCustomCapital"><font-awesome-icon icon="check" style="margin-right:5px;" />確定</el-button>
                <el-button type="danger" @click="showCustomCapital=false"><font-awesome-icon icon="times" style="margin-right:5px;" />取消</el-button>
            </span>
        </el-dialog>

        <!-- 自訂設立日期區間對話框 -->
        <el-dialog title="自訂設立日期區間" :visible.sync="showCustomYear" width="40%" center>
            <div class="dialogBox">
                <el-form label-width="100px">
                    <el-form-item label="起始年限">
                        <el-input v-model="customYear.start" placeholder="請輸入起始年限（年）" type="number">
                            <template slot="append">年</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="結束年限">
                        <el-input v-model="customYear.end" placeholder="請輸入結束年限（年）" type="number">
                            <template slot="append">年</template>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmCustomYear"><font-awesome-icon icon="check" style="margin-right:5px;" />確定</el-button>
                <el-button type="danger" @click="showCustomYear=false"><font-awesome-icon icon="times" style="margin-right:5px;" />取消</el-button>
            </span>
        </el-dialog>        
        
    </div>

</template>

<script>

import wordcloud from 'vue-wordcloud';
import { notify, handleError } from  '../../utils/notify';
import DistSelection from '../../components/DistSelection.vue'; // 新增引入
import IndusCodeSelection from '@/components/IndusCodeSelection.vue'
import { 
  formatCurrency, 
  formatCapital, 
  formatDate, 
  formatAddressBrief, 
  formatBriefing,
  extractIndustryCode,
  splitIndustryCode  
} from '../../utils/formatters'; // 新增格式化工具

export default {
  components: { 
    wordcloud, 
    DistSelection,
    IndusCodeSelection
  },
  
  data() {
        return {          
            // 控制按鈕 如果是DO, APA, AP 角色, 則 無儲存, 載入搜尋條件及新增標籤, 新增潛在客戶 功能
            btnAdvFuncVisible: false,

            selectedIndustryCode: [], // 單選：['A', '01', '011', '0111']
            selectedRows: [], // 儲存使用者勾選的項目

            selectedProjectName: "",
            // 左側標籤抽屜相關
            tagDrawerVisible: false,
            tagDrawerWidth: '25%',
            showAddTagDialog: false,
            splitStdTags: [],
            selectedCompanyTags: {
                company: null,   
                type: 'br', // 'br' 或 'hq' 
                br_tags: [],
                hq_tags: []
            },  
            btnHotTag: false, // 熱門標籤按鈕顯示控制
            newTagFormType: 'br', // 預設為自訂標籤
            newTagFormTypeMulti: 'br', // 用於多選標籤類型
            newTagForm: {
                content: '',
                type: 'br' // 'hq' 或 'br'
            },                      
            
            tags_array: ['公司類別', '產業別', '進口', '出口', '工廠', '供應商', '陸資', '投資', '認證', '赴大陸', '獲獎', '領域', '商標', '園區', '裁罰'],
            tags_array2: [
                { "label": '公司類別', "show": true },
                { "label": '產業別', "show": true },
                { "label": '進口', "show": true },
                { "label": '出口', "show": true },
                { "label": '工廠', "show": true },
                { "label": '供應商', "show": true },
                { "label": '陸資', "show": true },
                { "label": '投資', "show": true },
                { "label": '認證', "show": true },
                { "label": '赴大陸', "show": true },
                { "label": '獲獎', "show": true },
                { "label": '領域', "show": true },
                { "label": '商標', "show": true },
                { "label": '園區', "show": true },
                { "label": '裁罰', "show": true }
            ],

            selectedComStatus: "全部",
            selectedOrgType: "全部",
            selectedComType: "全部",            
            // 地區選擇相關（簡化後）
            selectedAreaValue: ['全部', '全部'],
            
            reasonDesc: "",
            ssName: "",
            ssDesc: "",
            selSaveSearch: "",
            lstLoadQuery: [],
            lssDesc: "",
            btnArea: "營業區域",

            // 自訂資本額區間
            showCustomCapital: false,
            customCapital: {
                start: '',
                end: ''
            },



            showTag: false,
            showSaveSearch: false,
            showLoadSearch: false,
            showTagCloud: false,            
            showPotCustomer: false,
            
            tableData: [],
            totalLists: 0,

            // 其他篩選條件
            IsImport: false,
            IsExport: false,
            IsInvoice: false,
            IsCustomer: false,
            IsFactory: false,            

            keyword:"", 
            industryCode:"",        
            
            selectedComType: [],
            selectedCity: "臺北市",
            selectedDistrict: "",


            selProjectName: "",
            selCustomer: "",
            selCity: "全部",
            saveSearchList: [],
            lstIndusCode: [],
            preciseTagMappings: [
                { key: 'invest_area', title: '對外投資', isHyperlink: true },
                { key: 'is_china_fund', title: '陸資來台投資', isHyperlink: true },
                { key: 'is_invest_china', title: '赴中國大陸投資', isHyperlink: true },
                { key: 'award_name', title: '獲獎記錄', isHyperlink: true },
                { key: 'certification', title: '專業認證', isHyperlink: true },
                { key: 'domain_name', title: '企業領域', isHyperlink: true },
                { key: 'brand_name', title: '品牌商標', isHyperlink: true },
                { key: 'park_name', title: '所在園區', isHyperlink: true },
                { key: 'alarm_item', title: '裁罰警示', isHyperlink: true },
                { key: 'industry', title: '相關產業', isHyperlink: true },
                { key: 'industry_type', title: '相關產業', isHyperlink: true },
                { key: 'product', title: '相關產品', isHyperlink: true },
                {key: 'hq_category', title: '總行標籤', isHyperlink: true},
                {key: 'br_category', title: '自訂標籤', isHyperlink: true},
                {key: 'company_type', title: '公司類別', isHyperlink: true},
                {key: 'is_import', title: '進口廠商', isHyperlink: true},
                {key: 'is_export', title: '出口廠商', isHyperlink: true},
                {key: 'is_supplier', title: '合格供應商 ', isHyperlink: true},
                {key: 'import_value', title: '進口實績 ', isHyperlink: true},
                {key: 'export_value', title: '出口實績 ', isHyperlink: true},

            ],
            // 原有的 lstQuery（顯示用）
            lstQuery: [],
            // 新增：結構化的查詢條件（用於 API 查詢）
            queryConditions: {
                keyword: '',           // 關鍵字
                companyStatus: '',     // 公司狀況
                companyType: [],       // 公司類別
                orgType: [],          // 組織別
                isCustomer: false,    // 既有客戶
                isInvoice: false,     // 有發票
                isImport: false,      // 有進口
                isExport: false,      // 有出口
                isFactory: false,     // 有工廠
                capital: {            // 資本額
                    start: '',
                    end: '',
                    range: ''         // 如 "0~100萬"
                },
                setupDate: {          // 設立日期
                    range: '',        // 如 "1-3年"
                    start: '',        // 計算後的開始日期，如 "2020-01-01"
                    end: '',          // 計算後的結束日期，如 "2022-12-31"
                    rangeValue: ''    // yearList 的 value
                },
                industryCode: [],     // 行業代碼
                preciseTags: [],      // 精準標籤查詢 [{ category: 'au_xxx', display_name: '關鍵字' }]
                comloc: '',           // 完整地址關鍵字（ComLoc）
                location: {           // 地址
                    area: '',         // 區域：北部/中部/南部/東部
                    city: '',         // 縣市
                    district: ''      // 區域
                },
                geolocation: {        // 地理位置
                    Latitude: '',     // 緯度
                    Longitude: '',    // 經度
                    Distance: ''      // 距離，單位公里
                }                
            },
            // 新增：查詢條件映射表（用於標籤與結構的對應）
            queryConditionMap: new Map(),

            radCap: "",
            yearCap: "",            

            TotCapStart:"",
            TotCapEnd:"",     

            sIndusCode:"",      
            
            IndusCodes: [],
            tagModel: {
                field: "cu_tags",
                text: "",
            },

            companyDetail: {},
            
            checkedCompanies : "",

            listQuery: {
                ie_Import:"有",
                ie_Export:"有",
                tx_UseInvoice:"Y",
                comLoc:"",
                searchContent:"",
                totCap:["",""],
                Page_Size:10,
                Page_Num:1
            },

            capList: [
                { cap: "2000萬(含)以下", value: 1, start: 0, end: 2000 },
                { cap: "2001萬~3000萬(含)以下", value: 2, start: 2001, end: 3000 },
                { cap: "3001萬~8000萬(含)以下", value: 3, start: 3001, end: 8000 },
                { cap: "8001萬~1億(含)以下", value: 4, start: 8001, end: 10000 },
                { cap: "1億(不含)以上", value: 5, start: 10001, end: 999999999 }        
            ],

            yearList: [
                { cap: "未滿1年", start: 0, end: 1, value: 1 },
                { cap: "1年以上-未滿3年", start: 1, end: 3, value: 2 },
                { cap: "3年以上-未滿5年", start: 3, end: 5, value: 3 },
                { cap: "5年以上-未滿10年", start: 5, end: 10, value: 4 },
                { cap: "10年(含)以上", start: 10, end: 20, value: 5 }          
            ],

            industryCodeNameMap: {},

            // 自訂設立日期區間
            showCustomYear: false,
            customYear: {
                start: '',
                end: ''
            },

            // 組織別相關
            OrgTypeList: [
                { comType: "股份有限公司" },
                { comType: "有限公司" },
                { comType: "獨資" },
                { comType: "合夥" },
                { comType: "其他" }
            ],
            ComTypeList: [
                { comType: "上市" },
                { comType: "上櫃" },
                { comType: "興櫃" },
                { comType: "公開發行" }
            ],            
     
                    
            areaList: [
                {area: "全部", cities: ["全部"]},
                {area: "北部", cities: ["臺北市", "新北市", "桃園市", "新竹市", "新竹縣", "宜蘭縣", "基隆市"]},
                {area: "中部", cities: ["臺中市", "彰化縣","苗栗縣", "南投縣", "雲林縣"]},
                {area: "南部", cities: ["高雄市", "臺南市", "嘉義市", "嘉義縣", "屏東縣"]},
                {area: "東部", cities: ["花蓮縣", "臺東縣","澎湖縣","金門縣","連江縣"]}
            ],

            ProjectNameList: [],         

            
            myColors: ['#1f77b4', '#629fc9', '#94bedb', '#c9e0ef'],

            rotateText: {
                from: -0,
                to: 0,
                numOfOrientation: 5
            },
            hotTagsList: []


        }
    },
    computed: {
        // 處理br_tags字串分割
        splitBrTags() {
            if (this.selectedCompanyTags.br_tags) {
                if (Array.isArray(this.selectedCompanyTags.br_tags)) {
                    // 如果是陣列，直接返回（過濾空字串）
                    console.log('自訂標籤陣列:', this.selectedCompanyTags.br_tags);
                    return this.selectedCompanyTags.br_tags.filter(tag => tag && tag.name.trim().length > 0);
                }
            }
            return [];
        },
        
        // 處理hq_tags字串分割
        splitHqTags() {
            if (this.selectedCompanyTags.hq_tags) {
                if (Array.isArray(this.selectedCompanyTags.hq_tags)) {
                    // 如果是陣列，直接返回（過濾空字串）
                    console.log('總行標籤陣列:', this.selectedCompanyTags.hq_tags);
                    return this.selectedCompanyTags.hq_tags.filter(tag => tag && tag.name.trim().length > 0);
                }
            }
            return [];
        },
        
        // 日期格式化
        filterDate() {
            return (date) => {
                return this.$dayjs(date).format("YYYY-MM-DD");
            };
        },
        
        // 摘要格式化
        briefing() {
            return (str) => {
                return formatBriefing(str, 20);
            };
        },

        // 對話框相關計算屬性
        currentCustomerFields() {
            return [
                {
                    key: 'companyInfo',
                    type: 'slot',
                    label: '公司名稱'
                },
                {
                    key: 'projectId',
                    type: 'select',
                    label: '專案名稱',
                    placeholder: '請選擇分類',
                    options: this.ProjectNameList.map(item => ({
                        value: item.ProjID,
                        label: item.ProjName
                    })),
                    span: 24
                },
                {
                    key: 'reasonDesc',
                    type: 'textarea',
                    label: '備註',
                    placeholder: '簡明描述推薦加入潛在客戶的原因',
                    rows: 2,
                    span: 24
                }
            ]
        },

        currentSaveSearchData() {
            return {
                name: this.ssName,
                conditions: this.lstQuery,
                description: this.ssDesc
            }
        },

        saveSearchOptions() {
            return this.saveSearchList.map(item => ({
                value: item.name,
                label: item.name,
                description: item.memo
            }))
        },

        industryCodeOptions() {
            return this.lstIndusCode.map(code => ({
                value: code,
                label: code
            }))
        },

        cascaderOptions() {
            // 根據 areaList 轉換為 cascader 格式
            const options = [];
            
            // 處理全部選項
            options.push({
                value: '全部',
                label: '全部',
                children: [{ value: '全部', label: '全部' }]
            });
            
            // 處理各區域
            this.areaList.filter(item => item.area !== '全部').forEach(area => {
                const children = area.cities.map(city => ({
                    value: city,
                    label: city,
                    leaf: false // 標記為非葉節點，表示還有下一級
                }));
                
                options.push({
                    value: area.area,
                    label: area.area,
                    children: children
                });
            });
            
            return options;
        }
    },

    methods: {
        // 格式化函數（從 utils/formatters 導入）
        formatCurrency,
        formatCapital,
        formatDate,
        formatAddressBrief,
        formatBriefing,
        extractIndustryCode,
        splitIndustryCode,

        getRowKey(row) {
            return row && row.DataID ? row.DataID : '';
        },        

        async loadIndustryCodeNameMap() {
            try {
                const response = await fetch('/indusCode.json');
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const json = await response.json();
                const map = {};

                const walk = (nodes = []) => {
                    nodes.forEach(node => {
                        if (node && node.value && node.label) {
                            map[node.value] = node.label;
                        }
                        if (node && Array.isArray(node.children) && node.children.length > 0) {
                            walk(node.children);
                        }
                    });
                };

                walk(json?.data || []);
                this.industryCodeNameMap = map;
            } catch (error) {
                console.error('載入行業代號名稱對照失敗:', error);
                this.industryCodeNameMap = {};
            }
        },

        formatIndustryCodeDisplay(value) {
            if (Array.isArray(value)) {
                return value.map(code => this.industryCodeNameMap[code] || code);
            }

            if (typeof value === 'string') {
                return this.industryCodeNameMap[value] || value;
            }

            return value || null;
        },

        // 處理表格勾選變更
        handleSelectionChange(selection) {
            this.selectedRows = selection;


        },

        // 保存新標籤
        async saveNewTag() {
            if (!this.newTagForm.content.trim()) {
                notify( {title:'請注意', type:'warning', message: '請輸入標籤內容'} );
                return;
            }
            
            if (!this.selectedRows || this.selectedRows.length === 0) {
                notify( {title:'請注意', type:'warning', message: '未選擇公司'} );            
                return;
            }
        
            // 若newTagForm.content中有多個標籤，以,分隔，組成陣列
            const tagArray = this.newTagForm.content.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
            
            this.getSelectedUniComNms().forEach(uniComNm => {
                const params = {
                        "UniComNm": uniComNm,
                        "TagValues": tagArray
                };           
                console.log('新增標籤參數:', params);
                // ##################################
                // 如果角色是. HE, HD, HC HC1, 則在POP中, 多一個選項, 讓使用者選要用什麼身份... 呼叫 add_hq_category_tag 
                // newTagFormType 'hq' 或 'br'
                // ##################################
                if( this.newTagFormTypeMulti == 'hq' ) {
                    this.$api.apitags.add_hq_category_tag(params).then(response => {
                        console.log('新增總公司標籤成功:', response);  
                                           
                        notify({ type: 'success', title: '成功', message: `已成功新增總公司標籤` });
                    }).catch(error => {
                        handleError(error, '新增總公司標籤失敗');
                    });       
                }
                else {
                    this.$api.apitags.add_category_tag(params).then(response => {
                        console.log('新增標籤成功:', response);   
                        notify({ type: 'success', title: '成功', message: `已成功新增自訂標籤` });
                    }).catch(error => {
                        handleError(error, '新增自訂標籤失敗');
                    });
                }

            });

            // 新增企業標籤後，該公司會從列表消失，要再加另一個公司標籤時，前公司輸入的標籤仍存在
            // 原因是呼叫了 refresh , 重新排序, 當然就不見了..
            // setTimeout( async () => {
            //     // 重新取得列表資料
            //     this.getList();
            // }, 1000);

            // 需要把pop 清空
            this.newTagForm.content = '';
            
            // multipleTable 清除勾選
            this.$refs.multipleTable.clearSelection();
            await this.getList();
            // 關閉對話框
            this.showTag = false;
        },        

        getSelectedComNames() {
            if( this.selectedRows.length>1)
                return this.selectedRows[0].ComName + " 等 " + this.selectedRows.length + " 筆";
            else 
                return this.selectedRows.length > 0 ? this.selectedRows[0].ComName : '';
        },

        // 取得勾選的統一編號
        getSelectedUniComNms() {
            return this.selectedRows.map(row => row.UniComNm);
        },

// 計算完整地址
        fullAddress(detail) {
            
            if (!detail || Object.keys(detail).length === 0) {
                return '';
            }
            
            let address = '';
            
            // 拼接地址各個部分
            if (detail.City) address += detail.City;
            if (detail.District) address += detail.District;
            if (detail.Village) address += detail.Village;
            if (detail.Street) address += detail.Street;
            if (detail.Lane) address += detail.Lane + '巷';
            if (detail.Alley) address += detail.Alley + '弄';
            if (detail.Nebrh) address += detail.Nebrh + '鄰';
            if (detail.Section) address += detail.Section + '段';
            if (detail.No) address += detail.No + '號';
            if (detail.Floor) address += detail.Floor + '樓';
            
            return address;
        },        

        // 處理專案名稱的新增、修改、刪除
        handleProjectName(command) {
            if (command === 'add') {
                // 處理新增專案名稱邏輯
                this.addProjectName();                
            } else if (command === 'edit') {
                // 處理修改專案名稱邏輯
                this.editProjectName();
            } else if (command === 'delete') {
                // 處理刪除專案名稱邏輯
                this.deleteProjectName();
            }
        },

        saveCustomer() {
            // this.selectedRows 包含使用者勾選的公司資料
            // this.selectedProjectName 包含使用者選擇的專案名稱
            if( !this.selectedProjectName ) {
                notify({ type: 'warning', title: '警告', message: '請先選擇專案名稱' });
                return;
            }


            this.selectedRows.forEach(row => {
                
                const qry = {
                    "UniComNm": row.UniComNm,
                    "ComName": row.ComName,
                    "ProjectID": this.selectedProjectName
                }                
                // console.log('新增潛在客戶:', row.UniComNm, row.ComName, '至專案:', this.selectedProjectName);
                // 在此處呼叫 API 或執行其他邏輯以儲存潛在客戶
                this.$api.apipocx.pocx_create(qry).then(response => {
                    console.log('新增潛在客戶成功:', response);
                    if (response.statuscode==200) {                    
                        notify({ type: 'success', title: '成功', message: `已成功新增潛在客戶: ${row.ComName}` });

                    }
                    else
                        notify({ type: 'error', title: '失敗', message: `新增潛在客戶失敗: ${row.ComName}，原因：${response.message}` });
                }).catch(error => {
                    handleError(error, '新增潛在客戶失敗');
                });
            });           

            // 清除 multipleTable 所勾選的項目
            this.$refs.multipleTable.clearSelection();
            
            this.showPotCustomer = false;
        },

        // 決定那些標籤要顯示
        showTags(detail) {        
            //['公司類別', '產業別', '進口', '出口', '工廠', '供應商', '陸資', '投資', '認證', '赴大陸', '獲獎', '領域', '商標', '園區', '裁罰']    
            let ret = [];

            // 公司類別
            if( detail.au_comtype?.length > 0 )
                ret.push(detail.au_comtype);
            // 產業別
            if( detail.au_industrytype?.length > 0 )
                ret.push(detail.au_industrytype);
            // 既有客戶
            if( detail.au_is_existing_customer && detail.au_is_existing_customer.length > 0 )
                ret.push("既有客戶");
            // 出進口
            if( detail.au_is_import || detail.au_is_export)
                ret.push("出進口");            
            // 工廠
            if( detail.au_is_factory )
                ret.push("工廠");                
            // 供應商
            if( detail.au_is_supplier)
                ret.push("供應商");
            // 陸資來臺投資
            if( detail.au_is_china_fund )
                ret.push("陸資");
            // 投資
            if( detail.au_invest_area )
                ret.push("投資");            
            // 赴中國大陸投資
            if( detail.au_is_invest_china )
                ret.push("赴大陸");
            // 獲獎名稱
            if( detail.au_award_name )
                ret.push("獲獎");
            // 認證名稱
            if( detail.au_certification )
                ret.push("認證");
            // 領域名稱
            if( detail.au_domain_name )
                ret.push("領域");
            // 商標
            if( detail.au_brand_name )
                ret.push("商標");
            // 所在園區
            if( detail.au_park_name )
                ret.push("園區");
            // 裁罰警示
            if( detail.au_alarm_item )
                ret.push("裁罰");
            return ret;

        },        

        async addCustomer() {
            // 檢核是否有勾選公司
            if( this.selectedRows.length == 0 ) {
                notify({ type: 'warning', title: '警告', message: '請先勾選欲新增為潛在客戶的公司' });
                return;
            }
            // 如果公司名稱超過1個, 則顯示第一個公司名稱, 並用...等this.selectedRows.Length 個公司
            if (this.selectedRows.length > 1) {
                this.checkedCompanies = this.selectedRows[0].ComName + '...等' + this.selectedRows.length + '個公司';
            } else {
                this.checkedCompanies = this.selectedRows[0].ComName;
            }

            

            this.showPotCustomer = true;
        },

        async doTags() {
            // 檢核是否有勾選公司
            if( this.selectedRows.length == 0 ) {
                notify({ type: 'warning', title: '警告', message: '請先勾選欲新增標籤的公司' });
                return;
            }
            this.showTag = true;
        },                

        async pageChange(val) {
            this.listQuery.Page_Num = val;
            await this.getList();
        },   

        async doShowCompanyDetail(data) {
            console.log(data);
            const comid = data.UniComNm;
            const comname = data.ComName;

            this.$queryRecord(this, comname, 'company');  // 記錄點擊公司名

            // 開啟新視窗, 顯示公司詳細資訊
            const url = `/companyDetail?comid=${comid}&comname=${comname}`;
            window.open(url, '_blank');		
            
        },        
        async doShowSimilarCompany(data) {

            console.log(data);

            // const comId = data.UniComNm;
            let indusCodes = [];
            // if( data.IndusNm && data.IndusNm.length>0 ) {
            //     indusCodes.push(data.IndusNm);
            // }
            // if( data.IndusNm1 && data.IndusNm1.length>0 ) {
            //     indusCodes.push(data.IndusNm1);
            // }
            // if( data.IndusNm2 && data.IndusNm2.length>0 ) {
            //     indusCodes.push(data.IndusNm2);
            // }
            // if( data.IndusNm3 && data.IndusNm3.length>0 ) {
            //     indusCodes.push(data.IndusNm3);
            // }

            // const IndusStr = indusCodes.join(',');
            // console.log('IndusStr', IndusStr);
            // let routeUrl = this.$router.resolve({
            //     path: "/ctmDetail",
            //     query: { id: comId, city: data.City, indusCode: IndusStr },
            // });

            // 改成用 params 傳遞
            if( data.IndusNm && data.IndusNm.length>0 ) {
                indusCodes.push({ "IndusType" : data.IndusType, "IndusNm": data.IndusNm });
            } 
            if( data.IndusNm1 && data.IndusNm1.length>0 ) {
                indusCodes.push({ "IndusType" : data.IndusType1, "IndusNm": data.IndusNm1 });
            }
            if( data.IndusNm2 && data.IndusNm2.length>0 ) {
                indusCodes.push({ "IndusType" : data.IndusType2, "IndusNm": data.IndusNm2 });
            }
            if( data.IndusNm3 && data.IndusNm3.length>0 ) {
                indusCodes.push({ "IndusType" : data.IndusType3, "IndusNm": data.IndusNm3 });
            }

            console.log('導向地圖頁面，參數：', indusCodes);
            const routeUrl = this.$router.resolve({ name: 'ctmDetail', query: { indusCodes: JSON.stringify(indusCodes), id: data.UniComNm,city: data.City, district: data.District, comname: data.ComName } });
            window.open(routeUrl.href, "_blank");
        },        

        async wordClickHandler(name, value) {
            // console.log('wordClickHandler', name, value, vm);
            // this.keyword = name;

            this.$queryRecord(this, name, 'tag','總行標籤');  // 記錄點擊Tag
            // 若點擊熱門標籤，則清除其他查詢條件，僅以該標籤作為查詢條件進行搜尋
            this.clearAllQueryConditions();            
            this.addQueryCondition('preciseTag', {
                category: 'hq_category',
                name
            }, '', 'hq_category');				

            this.showTagCloud = false;
            await this.getList();
        },           

        async getDeptList() {
            this.$store.dispatch("loadingHandler", true);

            this.$store.dispatch("loadingHandler", false);
        },        

        SearchIndusCode() {
            if( this.sIndusCode?.length>0) {
                let qry = {induscode: this.sIndusCode};
                //console.log(qry);
                this.$api.ctm.searchIndusCode(qry).then((res)=>{
                    console.log(res);
                    this.lstIndusCode = res.hits.hits.map(x=>x._source.indusCode).slice(0, 12);
                    console.log(this.lstIndusCode);
                }, err => {
                    handleError(err, '網路發生錯誤');
                });
            }
        },

        getPreciseTagTitle(tagKey) {
            if (!tagKey) return '';
            const tagInfo = this.preciseTagMappings.find(item => item.key === tagKey);
            return tagInfo ? tagInfo.title : tagKey;
        },

        buildTagDisplayText(tag, value, fallbackDisplayText = '') {
            if (!tag) return fallbackDisplayText;
            const title = this.getPreciseTagTitle(tag);

            let keyword = '';
            if (value && typeof value === 'object' && !Array.isArray(value)) {
                keyword = value.display_name || value.name || value.keyword || '';
            } else if (value !== null && value !== undefined) {
                keyword = String(value);
            }

            if (!keyword) return fallbackDisplayText || title;
            return `${title}:${keyword}`;
        },

        // 新增查詢條件（同時更新 lstQuery 和 queryConditions）
        addQueryCondition(type, value, displayText, tag = '') {
            const resolvedDisplayText = this.buildTagDisplayText(tag, value, displayText);

            // 1. 更新顯示標籤
            if (resolvedDisplayText && !this.lstQuery.includes(resolvedDisplayText)) {
                this.lstQuery.push(resolvedDisplayText);
            }
            
            // 2. 更新結構化資料
            switch(type) {
                case 'keyword':
                    this.queryConditions.keyword = value;
                    break;
                    
                case 'companyStatus':
                    this.queryConditions.companyStatus = value;
                    break;
                    
                case 'companyType':
                    if (!this.queryConditions.companyType.includes(value)) {
                        this.queryConditions.companyType.push(value);
                    }
                    break;
                    
                case 'orgType':
                    if (!this.queryConditions.orgType.includes(value)) {
                        this.queryConditions.orgType.push(value);
                    }
                    break;
                    
                case 'isCustomer':
                    this.queryConditions.isCustomer = value;
                    break;
                    
                case 'isInvoice':
                    this.queryConditions.isInvoice = value;
                    break;
                    
                case 'isImport':
                    this.queryConditions.isImport = value;
                    break;
                    
                case 'isExport':
                    this.queryConditions.isExport = value;
                    break;
                    
                case 'isFactory':
                    this.queryConditions.isFactory = value;
                    break;
                    
                case 'capital':
                    this.queryConditions.capital = value;
                    break;
                    
                case 'setupDate':
                    this.queryConditions.setupDate = value;
                    break;
                    
                case 'industryCode':
                    if (!this.queryConditions.industryCode.includes(value)) {
                        this.queryConditions.industryCode.push(value);
                    }
                    break;

                case 'preciseTag': {
                    const preciseTag = value && typeof value === 'object'
                        ? {
                            category: value.category || tag,
                            display_name: value.display_name || value.name || ''
                        }
                        : { category: tag, display_name: value };

                    if (!Array.isArray(this.queryConditions.preciseTags)) {
                        this.queryConditions.preciseTags = [];
                    }

                    if (!preciseTag.category || !preciseTag.display_name) {
                        break;
                    }

                    const exists = this.queryConditions.preciseTags.some(item =>
                        item.category === preciseTag.category &&
                        (item.display_name || item.name) === preciseTag.display_name
                    );

                    if (!exists) {
                        this.queryConditions.preciseTags.push(preciseTag);
                    }
                    break;
                }

                case 'comloc':
                    this.queryConditions.comloc = value;
                    break;
                    
                case 'location':
                    this.queryConditions.location = value;
                    break;

                case 'geolocation':
                    this.queryConditions.geolocation = value;
                    break;
            }
            
            // 3. 建立映射關係（標籤文字 -> 條件類型和值）
            if (resolvedDisplayText) {
                this.queryConditionMap.set(resolvedDisplayText, { type, value, tag });
            }
            
            console.log('查詢條件已更新:', {
                displayTags: this.lstQuery,
                structuredData: this.queryConditions,
                mapping: Array.from(this.queryConditionMap.entries())
            });
        },
        
        // 移除查詢條件
        removeQueryCondition(displayText, tag = '') {
            const resolvedDisplayText = this.buildTagDisplayText(tag, '', displayText);

            // 1. 從顯示標籤中移除
            const index = this.lstQuery.indexOf(resolvedDisplayText);
            if (index > -1) {
                this.lstQuery.splice(index, 1);
            }
            console.log(`this.queryConditionMap`, this.queryConditionMap);
            // 2. 從結構化資料中移除
            const mapping = this.queryConditionMap.get(resolvedDisplayText);
            if (mapping) {
                const { type, value, tag: mappedTag } = mapping;
                console.log(`移除查詢條件: 類型=${type}, 值=${value}`);

                switch(type) {
                    case 'keyword':
                        this.queryConditions.keyword = '';
                        this.keyword = '';
                        break;
                        
                    case 'companyStatus':
                        this.queryConditions.companyStatus = '';
                        this.selectedComStatus = '全部';
                        break;
                        
                    case 'companyType':
                        const ctIndex = this.queryConditions.companyType.indexOf(value);
                        if (ctIndex > -1) {
                            this.queryConditions.companyType.splice(ctIndex, 1);
                        }
                        break;
                        
                    case 'orgType':
                        const otIndex = this.queryConditions.orgType.indexOf(value);
                        if (otIndex > -1) {
                            this.queryConditions.orgType.splice(otIndex, 1);
                        }
                        break;
                        
                    case 'isCustomer':
                        this.queryConditions.isCustomer = false;
                        this.IsCustomer = false;
                        break;
                        
                    case 'isInvoice':
                        this.queryConditions.isInvoice = false;
                        this.IsInvoice = false;
                        break;
                        
                    case 'isImport':
                        this.queryConditions.isImport = false;
                        this.IsImport = false;
                        break;
                        
                    case 'isExport':
                        this.queryConditions.isExport = false;
                        this.IsExport = false;
                        break;
                        
                    case 'isFactory':
                        this.queryConditions.isFactory = false;
                        this.IsFactory = false;
                        break;
                        
                    case 'capital':
                        this.queryConditions.capital = { start: '', end: '', range: '' };
                        this.TotCapStart = '';
                        this.TotCapEnd = '';
                        this.radCap = '';
                        break;
                        
                    case 'setupDate':
                        this.queryConditions.setupDate = { range: '', start: '', end: '', rangeValue: '' };
                        this.yearCap = '';
                        break;
                        
                    case 'industryCode':
                        const icIndex = this.queryConditions.industryCode.indexOf(value);
                        if (icIndex > -1) {
                            this.queryConditions.industryCode.splice(icIndex, 1);
                        }
                        break;

                    case 'preciseTag': {
                        const preciseTag = value && typeof value === 'object'
                            ? {
                                category: value.category || mappedTag || tag,
                                display_name: value.display_name || value.name || ''
                            }
                            : { category: mappedTag || tag, display_name: value };

                        if (!Array.isArray(this.queryConditions.preciseTags)) {
                            this.queryConditions.preciseTags = [];
                        }

                        this.queryConditions.preciseTags = this.queryConditions.preciseTags.filter(item => {
                            return !(
                                item.category === preciseTag.category &&
                                (item.display_name || item.name) === preciseTag.display_name
                            );
                        });
                        break;
                    }

                    case 'comloc':
                        this.queryConditions.comloc = '';
                        this.listQuery.comLoc = '';
                        break;

                    case 'geolocation':
                        this.queryConditions.geolocation = { Latitude: '', Longitude: '', Distance: '' };
                        break;
                        
                    case 'location':
                        this.queryConditions.location = { area: '', city: '', district: '' };
                        this.selectedCity = '全部';
                        this.selectedDistrict = '';
                        // 也要把 selectedAreaValue 重設
                        this.selectedAreaValue = ['全部', '全部'];
                        break;
                }
                
                // 3. 從映射表中移除
                this.queryConditionMap.delete(resolvedDisplayText);
            }
        },
        
        // 清空所有查詢條件
        clearAllQueryConditions() {
            // 清空顯示標籤
            this.lstQuery = [];
            
            // 清空結構化資料
            this.queryConditions = {
                keyword: '',
                companyStatus: '',
                companyType: [],
                orgType: [],
                isCustomer: false,
                isInvoice: false,
                isImport: false,
                isExport: false,
                isFactory: false,
                capital: { start: '', end: '', range: '' },
                setupDate: { range: '', start: '', end: '', rangeValue: '' },
                industryCode: [],
                preciseTags: [],
                comloc: '',
                location: { area: '', city: '', district: '' },
                geolocation: { Latitude: '', Longitude: '', Distance: '' }
            };
            
            // 清空映射表
            this.queryConditionMap.clear();
            
            // 清空 UI 狀態
            this.keyword = '';
            this.selectedComStatus = '全部';
            this.selectedComType = '全部';
            this.selectedOrgType = '全部';
            this.IsCustomer = false;
            this.IsInvoice = false;
            this.IsImport = false;
            this.IsExport = false;
            this.IsFactory = false;
            this.TotCapStart = '';
            this.TotCapEnd = '';
            this.radCap = '';
            this.yearCap = '';
            this.selectedCity = '全部';
            this.selectedDistrict = '';
            this.selectedIndustryCode = [];
            this.selectedAreaValue = ['全部', '全部'];  // 清空區域選擇（非常重要！）
            
            // 清空 listQuery 物件中的查詢條件
            this.listQuery.comLoc = '';           // 清空地址（包含 City 和 District）
            this.listQuery.searchContent = '';    // 清空搜尋關鍵字
            this.listQuery.totCap = ['', ''];     // 清空資本額範圍
        },
      
             // 處理下拉選單指令
        handleCommand(command) {
            if (command === 'add') {
                this.addProjectName();
            } else if (command === 'edit') {
                this.editProjectName();
            } else if (command === 'delete') {
                this.deleteProjectName();
            }
        },
        
        // 新增專案名稱
        async addProjectName() {
            // 彈出輸入對話框
            this.$prompt('請輸入新的專案名稱', '新增專案名稱', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                inputPattern: /.+/,
                inputErrorMessage: '專案名稱不可為空',
                customClass: 'custom-prompt-dialog'
            }).then(async ({ value }) => {
                // 使用者輸入的專案名稱                
                const qry = {
                    "ProjectName": value.trim()
                };

                // 判斷value是否已存在於ProjectNameList
                const exists = this.ProjectNameList.some(item => item.ProjectName === value.trim());
                if (exists) {
                    notify({
                        title: "警告",
                        message: `專案名稱 "${value.trim()}" 已存在`,
                        type: "warning",
                    });
                    return;
                }
                
                try {
                    const res = await this.$api.apipocxpj.pocxpj_create(qry);
                    console.log('新增專案名稱成功:', res);
                    // 重新載入專案名稱列表
                    await this.loadProjectNameList(); 
                    this.selectedProjectName = res.data.ID; // 選擇剛新增的專案名稱
                    notify({
                        title: "成功",
                        message: `成功新增專案名稱 "${value.trim()}"`,
                        type: "success",
                    });

                } catch (err) {
                    handleError(err, '新增專案名稱失敗');
                }
            }).catch(() => {
                // 使用者取消輸入
            });


        },
        // 修改專案名稱
        editProjectName() {
            // 請檢查是否有選擇專案名稱
            if (!this.selectedProjectName) {
                notify({
                    title: "警告",
                    message: "請先選擇要修改的專案名稱",
                    type: "warning",
                });
                return;
            }

            this.$prompt('請輸入新的專案名稱', '修改專案名稱', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                inputValue: "",
                inputPattern: /.+/,
                inputErrorMessage: '專案名稱不可為空',
                customClass: 'custom-prompt-dialog'
            }).then(async ({ value }) => {
                // 使用者輸入的新的專案名稱
                const qry = {
                    "ID": this.selectedProjectName,
                    "ProjectName": value.trim()
                };
                
                try {
                    const res = await this.$api.apipocxpj.pocxpj_update(qry);
                    console.log('修改專案名稱成功:', res);

                    if( res.statuscode == 200 ) {
                        await this.loadProjectNameList();
                        notify({
                            title: "成功",
                            message: `成功修改專案名稱為 "${value.trim()}"`,
                            type: "success",
                        });
                    }
                    else {
                        notify({
                            title: "錯誤",
                            message: `修改專案名稱失敗: ${res.message || '未知錯誤'}`,
                            type: "error",
                        });
                    }
                } catch (err) {
                    handleError(err, '修改專案名稱失敗');
                }
            }).catch(() => {
                // 使用者取消輸入
            });

        },
        // 刪除專案名稱
        deleteProjectName() {

            // 請檢查是否有選擇專案名稱
            if (!this.selectedProjectName) {
                notify({
                    title: "警告",
                    message: "請先選擇要修改的專案名稱",
                    type: "warning",
                });
                return;
            }      
            // 由this.selectProjectName, 找出專案名稱
            const proj = this.ProjectNameList.find(item => item.ID == parseInt(this.selectedProjectName));
            
            console.log('準備刪除專案名稱:', proj);
            // 彈出確認對話框
            this.$confirm(`確定要刪除專案名稱 "${proj.ProjectName}" 及其所有潛在客戶 嗎?`, '刪除確認', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'custom-confirm-dialog'
            }).then(async () => {
                // 再將此專案中的所有潛在客戶都刪除
                // 先找出此專案名稱下的所有潛在客戶
                const qry = {
                    "ProjectName": proj.ProjectName,
                    "Page_Num": 1,
                    "Page_Size": 100
                };
                const respPocx = await this.$api.apipocx.pocx_search(qry);
                if( respPocx.data.length > 0 ) {
                    const idsToDelete = respPocx.data.map(item => item.ID);
                    console.log('刪除此專案下的潛在客戶IDs:', idsToDelete);
                    // 呼叫刪除API
                    const respDeletePocx = await this.$api.apipocx.pocx_delete( { IDs: idsToDelete } );
                    console.log('刪除潛在客戶結果:', respDeletePocx);
                }

                // 使用者確認刪除的處理邏輯
                console.log('刪除專案名稱:', proj.ProjectName);

                const res = await this.$api.apipocxpj.pocxpj_delete({ ID: this.selectedProjectName });


                
                // 從陣列中刪除所選項目
                const index = this.ProjectNameList.findIndex(item => item.ID == parseInt(this.selectedProjectName));
                if (index !== -1) {
                    this.ProjectNameList.splice(index, 1);
                }
                
                // 這裡可以加入從後端刪除專案名稱的程式碼
                this.$message({
                    type: 'success',
                    message: '專案名稱已成功刪除'
                });
                
                // 重置選擇
                this.selectedProjectName = '';
            }).catch(() => {
                // 使用者取消刪除
                this.$message({
                    type: 'info',
                    message: '已取消刪除操作'
                });
            });
        },

        searchTag(tag) {
            // 開啟新視窗並進行搜尋
            const baseUrl = window.location.origin; // 取得當前網站的基礎
            const searchUrl = `${baseUrl}/ctm?keyword=${tag}`;
            window.open(searchUrl, '_blank');
        },

        // 處理標籤按鈕點擊
        yearFormat(value) {
            if (!value || value.length < 4) return '';
            return value.slice(0, 4) + '年';
        },

        getStdTags() {

            // 二元性的標籤，不需要有hyperlink
            const binaryTagKeys = ["au_company_type","au_is_import","au_is_export","au_is_factory","au_is_supplier","au_is_china_fund"];

            let stdTags = [];
            if (this.selectedCompanyTags.company) {
                for (const key in this.selectedCompanyTags.company) {
                    if (key.startsWith('au_') && this.selectedCompanyTags.company[key]) {
                        this.selectedCompanyTags.company[key]?.forEach(item => {
                            // let tagStr = `${item.event_date ? this.yearFormat(item.event_date) : ''} ${item.name || ''}`;
                            let tagStr = item.display_name || item.name || '';
                            if (item.category === 'export_value') {
                                tagStr = `${item.event_date ? this.yearFormat(item.event_date) : ''} 出口 ${item.name || ''}級`;
                            }
                            if (item.category === 'import_value') {
                                tagStr = `${item.event_date ? this.yearFormat(item.event_date) : ''} 進口 ${item.name || ''}級`;
                            }
                            stdTags.push({
                                name: tagStr.trim(),
                                category: item.category || key.replace('au_', ''),
                                isHyperLink: binaryTagKeys.includes(key) ? false : true,
                            });
                        });
                    }
                }
            }
            return stdTags;
        },

        handleTagClick(tagStr, tagCategory, tagType = '標準標籤') {
            this.$queryRecord(this, tagStr, 'tag', tagType);
            console.log(`點擊了${tagType} - ${tagCategory}：`, tagStr);
            const baseUrl = window.location.origin;
            window.open(`${baseUrl}/ctm?keyword=${tagStr}&category=${tagCategory}&type=${tagType}`, '_blank');
        },

        openTagDrawer(item) {
            if (!item) {
                console.warn('openTagDrawer: item 為空');
                return;
            }
            
            console.log('標籤按鈕點擊：', item.UniComNm, item.ComName, item);
            
            // 立即顯示快取資料，開啟抽屜
            this.selectedCompanyTags = {
                company: item,
                br_tags: item.br_category || [],
                hq_tags: item.hq_category || []
            };
            this.splitStdTags = this.getStdTags();
            this.tagDrawerVisible = true;

            // 背景呼叫 search_bidmain 取得最新標籤（因後端為非同步處理）
            const UniComNm = item.UniComNm;
            this.$api.apies.search_bidmain({ SearchText: [UniComNm], Page_Size: 1, Page_Num:1 })
                .then(res => {
                    console.log('openTagDrawer: search_bidmain 回傳結果', res);
                    const fresh = res?.data?.[0] || res?.hits?.hits?.[0]?._source;
                    if (!fresh) return;
                    this.selectedCompanyTags = {
                        company: fresh,
                        br_tags: fresh.br_category || [],
                        hq_tags: fresh.hq_category || []
                    };
                    this.splitStdTags = this.getStdTags();
                    console.log('openTagDrawer: 已更新最新標籤資料', fresh);
                })
                .catch(err => {
                    console.warn('openTagDrawer: 取得最新標籤失敗，保留快取資料', err);
                });
        },
        
        // 打開新增標籤對話框
        openAddTagDialog() {
            // 重置表單
            this.newTagForm.content = '';
            // 顯示對話框
            this.showAddTagDialog = true;
        },
        
        // 從抽屜保存新標籤
        async saveNewTagFromDrawer() {
            if (!this.newTagForm.content.trim()) {
                notify({ title: '請注意', type: 'warning', message: '請輸入標籤內容' });
                return;
            }
            
            if (!this.selectedCompanyTags.company) {
                notify({ title: '請注意', type: 'warning', message: '未選擇公司' });
                this.showAddTagDialog = false;
                return;
            }
            
            // 若newTagForm.content中有多個標籤，以,分隔，組成陣列
            const tagArray = this.newTagForm.content.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
            
            const params = {
                "UniComNm": this.selectedCompanyTags.company.UniComNm,
                "TagValues": tagArray
            };
            console.log('新增標籤參數:', params);
            
            // 根據 newTagFormType 決定呼叫哪個 API
            try {
                if (this.selectedCompanyTags.type == 'hq') {
                    await this.$api.apitags.add_hq_category_tag(params);
                    console.log('新增總公司標籤成功');
                    notify({ type: 'success', title: '成功', message: `已成功新增總行標籤` });
                } else {
                    await this.$api.apitags.add_category_tag(params);
                    console.log('新增標籤成功');
                    notify({ type: 'success', title: '成功', message: `已成功新增自訂標籤` });
                }
            } catch (error) {
                handleError(error, '新增標籤失敗');
            }

            // 同時也把左方抽屜關閉
            this.tagDrawerVisible = false;
            // 關閉對話框
            this.showAddTagDialog = false;

            // 等待後端非同步處理完成後，重新取得列表
            await this.getList();
        },

    // 移除之前的地點選擇標籤
        removePreviousLocationTags() {
            // 定義可能的地點相關標籤模式
            const locationPatterns = [
                // 區域名稱
                '北部', '中部', '南部', '東部',
                // 縣市名稱 (包含常見的縣市)
                '臺北市', '新北市', '桃園市', '臺中市', '臺南市', '高雄市',
                '新竹市', '新竹縣', '苗栗縣', '彰化縣', '南投縣', '雲林縣',
                '嘉義市', '嘉義縣', '屏東縣', '宜蘭縣', '花蓮縣', '臺東縣',
                '澎湖縣', '金門縣', '連江縣', '基隆市'
            ];
            
            // 移除符合地點模式的標籤
            this.lstQuery = this.lstQuery.filter(tag => {
                // 檢查是否為地點標籤
                const isLocationTag = locationPatterns.some(pattern => tag.includes(pattern)) ||
                                    // 檢查是否包含"市"、"縣"、"區"等地點相關字詞
                                    /.*[市縣區鄉鎮].*/.test(tag) ||
                                    // 檢查是否為組合地址（如"臺北市中山區"）
//                                     /.*市.*區/.test(tag);
                                    false;
                
                return !isLocationTag;
            });
            
            console.log('移除地點標籤後的 lstQuery：', this.lstQuery);
        },        

        // 處理區域變更（從子組件接收事件）
        handleAreaChange(values) {
            console.log('父組件接收到區域變更（完整路徑）：', values);
            
            if (!values || values.length === 0) {
                this.selectedCity = "全部";
                this.selectedDistrict = "";
                this.btnArea = "營業區域";
                return;
            }
            
            // 先移除之前的地點選擇標籤
            this.removePreviousLocationTags();
            
            // 根據選擇層級決定顯示內容
            if (values.length === 1) {
                const area = values[0];
                this.selectedCity = "全部";
                this.selectedDistrict = "";
                this.btnArea = area;
                
                console.log('加入查詢條件的區域名稱：', area);
                
                if (area !== '全部') {
                this.lstQuery.push(area);
                }
            } else if (values.length === 2) {
                const area = values[0];    // 第一層：區域
                const city = values[1];    // 第二層：縣市
                this.selectedCity = city;
                this.selectedDistrict = "";
                this.btnArea = city;
                
                console.log('加入查詢條件的城市名稱：', city);
                
                if (city !== '全部') {
                this.listQuery.comLoc = city;
                this.lstQuery.push(city);
                }
            } else if (values.length === 3) {
                const area = values[0];      // 第一層：區域
                const city = values[1];      // 第二層：縣市  
                const district = values[2];  // 第三層：區域
                this.selectedCity = city;
                this.selectedDistrict = district;
                this.btnArea = `${city}${district}`;
                
                const txtAddress = `${city}${district}`;
                this.listQuery.comLoc = txtAddress;
                this.lstQuery.push(txtAddress);
                
                console.log('加入查詢條件的完整地址：', txtAddress);
            }
        },

        handleSaveSearch() {
            // 檢查 lstQuery 是否有內容
            if (this.lstQuery.length === 0) {
                this.$message({
                    message: '請先加入查詢條件後再儲存',
                    type: 'warning'
                });
                return;
            }
            this.showSaveSearch = true;
        },

        loadHotTags() {

            console.log("loadHotTags");
            const qry={"isSys":true};
            this.$api.apihottags.getAllHotTags(qry).then((res)=>{
                console.log('取得熱門標籤成功:', res);
                this.hotTagsList = res.data;
                // 取出第11個, 因為前面10個是系統預設的熱門標籤, 
                const enabledHotTags = this.hotTagsList[10];
                console.log('第11個熱門標籤（用於控制按鈕顯示）:', enabledHotTags);
                if( enabledHotTags.TagName=="Y" ) {
                    this.btnHotTag = true;
                }
                else {
                    this.btnHotTag = false;
                }   
                console.log('熱門標籤顯示狀態:', this.btnHotTag);   
                this.hotTagsList = this.hotTagsList.slice(0,10);
                // 新增Weight屬性, 利用SortOrder來決定字體大小, 第1名最大, 依序遞減
                // 利用LN函數來平滑字體大小差異
                const maxWeight = 20; // 最大字體大小
                this.hotTagsList.forEach((tag, index) => {
                    //tag.Weight = maxWeight - index; // 根據排序順序設定 Weight
                    tag.Weight = Math.max(1, Math.round(Math.log(maxWeight - index + 1) )); // 使用對數函數平滑字體大小
                });
                console.log('熱門標籤列表:', this.hotTagsList);
            }, err => {
                handleError(err, '取得熱門標籤失敗');
            });
        },

        // 由API中, 取得已儲存的搜尋條件列表
        async loadSaveSearchfromAPI() {
            //alert( this.btnAdvFuncVisible)
            if( this.btnAdvFuncVisible  ) // 如果進階功能按鈕不可見, 則不載入
            {
                console.log("loadSaveSearch from API");
                try {
                    const res = await this.$api.apisc.sc_search({});
                    console.log('取得已儲存的搜尋條件列表成功:', res);
                    // 轉換成 saveSearchList 格式
                    this.saveSearchList = res.data.map(item => {
                        // 先處理 query 的轉換
                        const queryTags = item.Parameters ? Object.entries(item.Parameters).map(([key, value]) => {
                            // 根據 key 轉換成顯示標籤
                            switch(key) {
                                case 'keyword':
                                    return value || null;
                                case 'companyStatus':
                                    return value || null;
                                case 'companyType':
                                    return value || null; // 假設 value 是陣列
                                case 'orgType':
                                    return value || null; // 假設 value 是陣列
                                case 'isCustomer':
                                    return value ? '既有客戶' : null;
                                case 'isInvoice':
                                    return value ? '開立發票' : null;
                                case 'isImport':
                                    return value ? '有進口' : null;
                                case 'isExport':
                                    return value ? '有出口' : null;
                                case 'isFactory':
                                    return value ? '有工廠' : null;
                                case 'capital':                                
                                    return (value.start && value.end) ? `${value.start}萬~${value.end}萬` : null;
                                case 'setupDate':
                                    //return (value.start && value.end) ? `${value.start} ~${value.end} ` : null;
                                    return value.range || null;
                                case 'industryCode':
                                    return this.formatIndustryCodeDisplay(value);
                                case 'preciseTags':
                                    if (Array.isArray(value)) {
                                        return value.map(tagItem => {
                                            const displayName = tagItem?.display_name || tagItem?.name;
                                            if (!tagItem || !displayName) return null;
                                            const title = this.getPreciseTagTitle(tagItem.category);
                                            return `${title}:${displayName}`;
                                        }).filter(x => x !== null);
                                    }
                                    return null;
                                case 'comloc':
                                    return value || null;
                                case 'location':
                                    return (value.city || value.district) ? `${value.city}${value.district}` : null;
                                default:
                                    return null;
                            }
                        }).flat().filter(x => x !== null) : [];    
                        console.log('轉換後的 queryTags:', item);               

                        return {
                            name: item.ConditionName,
                            memo: item.Memo || '',
                            query: queryTags,
                            conditions: item.Parameters || {},
                            mapping: item.Mapping || []
                        };
                    });
                    console.log('轉換後的儲存搜尋條件列表:', this.saveSearchList);
                    return this.saveSearchList;
                } catch (err) {
                    this.saveSearchList = [];
                    // handleError(err, '取得已儲存的搜尋條件列表失敗');
                    return [];
                }
            }
            else {
                console.log("進階功能按鈕不可見，不載入儲存的搜尋條件");
                this.saveSearchList = [];
                return [];
            }
            
        },        

        // 儲存搜尋條件
        saveSearch() {
            const conditionName = (this.ssName || '').trim();
            const memo = this.ssDesc || '';

            // 檢查this.ssName是否有值
            if (!conditionName) {
                notify({ type: 'warning', title: '警告', message: '請輸入搜尋條件名稱' });
                return;
            }

            // 限制 ConditionName 長度不可超過 100
            if (conditionName.length > 100) {
                notify({ type: 'warning', title: '警告', message: '條件名稱不得超過100個字' });
                return;
            }

            // 限制 Memo 長度不可超過 100
            if (memo.length > 100) {
                notify({ type: 'warning', title: '警告', message: '條件備註不得超過100個字' });
                return;
            }

            // 檢查 this.ssName是否已存在於 this.saveSearchList 中
            const exists = this.saveSearchList.some(item => item.name === conditionName);
            if (exists) {
                notify({ type: 'warning', title: '警告', message: `搜尋條件名稱 "${conditionName}" 已存在，請使用不同的名稱` });
                return;
            }

            // 儲存搜尋條件時
            let qry = {
                name: conditionName,
                desc: memo,
                displayTags: [...this.lstQuery],           // 顯示用的標籤
                conditions: { ...this.queryConditions },   // 結構化的查詢條件
                mapping: Array.from(this.queryConditionMap.entries())  // 映射關係
            };
            // console.log('已儲存搜尋條件:', qry);
            // console.log('目前儲存的搜尋條件列表:', this.saveSearchList);
            // console.log('queryConditions:', this.queryConditions);

            // 呼叫API儲存到後端
            this.$api.apisc.sc_create({
                    "ConditionName": conditionName,
                    "Memo": memo,
                    "Parameters": this.queryConditions                    
            }).then((res)=>{
                console.log('儲存搜尋條件到後端成功:', res);
                // this.saveSearchList.push(qry);
                notify({ type: 'success', title: '成功', message: `已成功儲存搜尋條件: ${conditionName}` });

                // 重新載入已儲存的搜尋條件列表
                this.loadSaveSearchfromAPI();
                
                this.showSaveSearch = false;
            }, err => {
                handleError(err, '儲存搜尋條件到後端失敗');
            });
        },

        changeSaveSearch() {
            console.log("changeSaveSearch");
            this.lstLoadQuery = [];
            
            console.log(this.saveSearchList);
            // 將selSaveSearch的query, 複製到lstQuery
            let qry = this.saveSearchList.find(x=>x.name==this.selSaveSearch);
            
            console.log("選取的項目",qry);
            if (!qry) {
                this.lssDesc = '';
                return;
            }
            this.lstLoadQuery = qry.query;
            this.lssDesc = qry.memo || '';
            //this.showLoadSearch = false;
        },

        // pop dialog 載入儲存的搜尋條件
        loadSaveSearch() {
            
            // 載入搜尋條件時
            let qry = this.saveSearchList.find(x=>x.name==this.selSaveSearch);
            // 清空目前的查詢條件
            this.clearAllQueryConditions();
            // 也要清空 selectedAreaValue 的選擇
            this.selectedAreaValue = ['全部', '全部'];
            console.log(qry);
            // 以 qry.conditions 的每個屬性重建查詢條件與標籤，透過 addQueryCondition 保持 lstQuery 與 queryConditionMap 同步
            const cond = qry.conditions || {};
            try {
                for (const key of Object.keys(cond)) {
                    const val = cond[key];
                    if (val === null || val === undefined || val === '') continue;
                    console.log('重建查詢條件:', key, val);
                    switch (key) {
                        case 'keyword':
                            this.addQueryCondition('keyword', val, val);
                            break;

                        case 'companyStatus':
                            this.addQueryCondition('companyStatus', val, val);
                            break;

                        case 'companyType':
                            if (Array.isArray(val)) val.forEach(v => this.addQueryCondition('companyType', v, v));
                            break;

                        case 'orgType':
                            if (Array.isArray(val)) val.forEach(v => this.addQueryCondition('orgType', v, v));
                            break;

                        case 'isCustomer':
                            if (val) this.addQueryCondition('isCustomer', true, '既有客戶');
                            break;

                        case 'isInvoice':
                            if (val) this.addQueryCondition('isInvoice', true, '開立發票');
                            break;

                        case 'isImport':
                            if (val) this.addQueryCondition('isImport', true, '有進口');
                            break;

                        case 'isExport':
                            if (val) this.addQueryCondition('isExport', true, '有出口');
                            break;

                        case 'isFactory':
                            if (val) this.addQueryCondition('isFactory', true, '有工廠');
                            break;

                        case 'capital':
                            if (val && (val.start || val.end || val.range)) {
                                const capDisplay = val.range || (val.start && val.end ? `${val.start}萬~${val.end}萬` : '');
                                this.addQueryCondition('capital', val, capDisplay);
                            }
                            break;

                        case 'setupDate':
                            if (val && (val.start || val.end || val.range)) {
                                const sdDisplay = val.range || (val.start && val.end ? `${val.start} ~${val.end}` : '');
                                this.addQueryCondition('setupDate', val, sdDisplay);
                            }
                            break;

                        case 'industryCode':
                            if (Array.isArray(val)) {
                                val.forEach(code => {
                                    const displayText = this.formatIndustryCodeDisplay(code);
                                    this.addQueryCondition('industryCode', code, displayText);
                                });
                            }
                            break;

                        case 'preciseTags':
                            if (Array.isArray(val)) {
                                val.forEach(tagItem => {
                                    const displayName = tagItem?.display_name || tagItem?.name;
                                    if (tagItem && tagItem.category && displayName) {
                                        this.addQueryCondition('preciseTag', {
                                            category: tagItem.category,
                                            display_name: displayName
                                        }, '', tagItem.category);
                                    }
                                });
                            }
                            break;

                        case 'comloc':
                            if (typeof val === 'string' && val.trim()) {
                                this.addQueryCondition('comloc', val.trim(), val.trim());
                            }
                            break;

                        case 'location':
                            if (val && (val.city || val.district || val.area)) {
                                const loc = val;
                                let displayText = '';
                                if (loc.city && loc.district) displayText = `${loc.city}${loc.district}`;
                                else if (loc.city) displayText = loc.city;
                                else if (loc.area) displayText = loc.area;
                                this.addQueryCondition('location', { area: loc.area || '', city: loc.city || '', district: loc.district || '' }, displayText);
                            }
                            break;
                        case 'geolocation':
                            if (val && (val.Latitude || val.Longitude || val.Distance)) {
                                // 儲存到結構化條件
                                this.queryConditions.geolocation = {
                                    Latitude: val.Latitude || '',
                                    Longitude: val.Longitude || '',
                                    Distance: val.Distance || ''
                                };
                                // 顯示文字，例如：距離10km內
                                const distText = val.Distance || '';
                                const display = distText ? `距離${distText}內` : '附近';
                                this.addQueryCondition('geolocation', this.queryConditions.geolocation, display);
                                // 同步可能的 UI 欄位
                                if (val.Latitude) this.latitude = val.Latitude;
                                if (val.Longitude) this.longitude = val.Longitude;
                            }
                            break;

                        default:
                            // 其他未處理的屬性，將其作為 unknown 類型標籤展示
                            alert(`有未知的key==>,${key},${val}`);
                            // if (Array.isArray(val)) {
                            //     val.forEach(v => {
                            //         if (v !== null && v !== undefined) this.addQueryCondition('unknown', v, String(v));
                            //     });
                            // } else {
                            //     this.addQueryCondition('unknown', val, String(val));
                            // }
                            break;
                    }
                }

                // 若後端同時回傳 display tags (qry.query)，且尚未從 conditions 建立，可補上缺漏
                if (Array.isArray(qry.query) && qry.query.length) {
                    qry.query.forEach(tag => {
                        if (!this.lstQuery.includes(tag)) {
                            // 無法完全判斷 type 時，用 unknown 作為占位
                            this.lstQuery.push(tag);
                            if (!this.queryConditionMap.has(tag)) {
                                this.queryConditionMap.set(tag, { type: 'unknown', value: tag });
                            }
                        }
                    });
                }
            } catch (e) {
                console.warn('從 qry.conditions 重建查詢條件時發生錯誤', e);
            }

            // 同步部分 UI 狀態
            this.keyword = this.queryConditions.keyword || '';
            this.IsCustomer = !!this.queryConditions.isCustomer;
            this.IsInvoice = !!this.queryConditions.isInvoice;
            this.IsImport = !!this.queryConditions.isImport;
            this.IsExport = !!this.queryConditions.isExport;
            this.IsFactory = !!this.queryConditions.isFactory;

            // 若 location 有值，更新選擇狀態
            if (this.queryConditions.location && (this.queryConditions.location.city || this.queryConditions.location.district || this.queryConditions.location.area)) {
                const loc = this.queryConditions.location;
                this.selectedAreaValue = [loc.area || '全部', loc.city || '全部'];
            }

            this.showLoadSearch = false;
        },

        doMap() {
            // 轉到ctmMap.vue頁面
            this.$router.push({ path: '/ctm-map' });
        },


        doshowDetail(row) {
            console.log(row);

            this.$queryRecord(this, row.ComName, 'company');  // 記錄點擊公司名
            // 開新頁面, 轉到ctmMapCx.vue頁面
            const url = `/ctmMapCom?unicomnm=${row.UniComNm}`;
            window.open(url, '_blank');

        },

        doshowMap(row) {            
            const fulladr = this.fullAddress(row);
            // 2024-06-17 改成開新視窗, 並帶參數    
            // const url = `/com-map?branch=${row.ComName}&lat=${row.Latitude}&lng=${row.Longitude}&loc=${fulladr}`;
            // window.open(url, '_blank');

            // 2025-12-29, 改成直接導向ctm-map頁面, 並帶參數
            console.log('導向地圖頁面，參數：', row);
            this.$router.push({ name: 'ctm-map', params: { searchmode: 'exact', comname: row.ComName, lat: row.Latitude, lng: row.Longitude, loc: fulladr, indusNum: row.IndusNm } });

        },

        // 執行搜尋
        doSearch() {
            console.log('執行搜尋');
            
            // 同步關鍵字到 queryConditions 和 lstQuery
            if (this.keyword && this.keyword.trim() !== '') {
                // 先移除舊的關鍵字標籤
                this.lstQuery = this.lstQuery.filter(tag => {
                    const mapping = this.queryConditionMap.get(tag);
                    return !mapping || mapping.type !== 'keyword';
                });
                
                // 添加新的關鍵字條件
                this.addQueryCondition('keyword', this.keyword, this.keyword);
            }
            
            // 重置分頁到第一頁
            this.listQuery.Page_Num = 1;
            if( this.keyword && this.keyword.trim() !== '' )
                this.$queryRecord(this, this.keyword, 'keyword');  // 記錄搜尋關鍵字
            // 執行查詢
            this.getList();
        },

        // 更新公司狀況處理
        comStatusChangeHandler(value) {
            console.log('公司狀況變更:', value);
            
            // 先移除舊的公司狀況標籤
            const statusTags = ['全部', '營業中', '非營業中'];
            statusTags.forEach(tag => {
                if (this.lstQuery.includes(tag)) {
                    this.removeQueryCondition(tag);
                }
            });
            
            // 添加新的條件
            if (value && value !== '全部') {
                this.addQueryCondition('companyStatus', value, value);
            }
            
            this.selectedComStatus = value;
        },
        
        // 更新公司類別處理
        comTypeChangeHandler(value) {
            console.log('公司類別變更:', value);
            
            if (value === '全部') {
                // 移除所有公司類別標籤
                this.ComTypeList.forEach(item => {
                    if (this.lstQuery.includes(item.comType)) {
                        this.removeQueryCondition(item.comType);
                    }
                });
            } else {
                // 先移除 "全部" 標籤
                if (this.lstQuery.includes('全部')) {
                    this.removeQueryCondition('全部');
                }
                
                // 添加新的公司類別
                this.addQueryCondition('companyType', value, value);
            }
            
            this.selectedComType = value;
        },
        
        // 更新組織別處理
        orgTypeChangeHandler(value) {
            console.log('組織別變更:', value);
            
            if (value === '全部') {
                // 移除所有組織別標籤
                this.OrgTypeList.forEach(item => {
                    if (this.lstQuery.includes(item.comType)) {
                        this.removeQueryCondition(item.comType);
                    }
                });
            } else {
                // 先移除 "全部" 標籤
                if (this.lstQuery.includes('全部')) {
                    this.removeQueryCondition('全部');
                }
                
                // 添加新的組織別
                this.addQueryCondition('orgType', value, value);
            }
            
            this.selectedOrgType = value;
        },
        
        // 更新其他條件處理
        otherChangeHandler(value) {
            const conditionMap = {
                '既有客戶': { type: 'isCustomer', checked: this.IsCustomer },
                '有發票': { type: 'isInvoice', checked: this.IsInvoice },
                '有進口': { type: 'isImport', checked: this.IsImport },
                '有出口': { type: 'isExport', checked: this.IsExport },
                '有工廠': { type: 'isFactory', checked: this.IsFactory }
            };
            
            const condition = conditionMap[value];
            if (condition) {
                if (condition.checked) {
                    this.addQueryCondition(condition.type, true, value);
                } else {
                    this.removeQueryCondition(value);
                }
            }
        },
        
        // 更新資本額處理
        radClick(val) {
            console.log(val);
            
            // 如果選擇自訂區間，開啟對話框
            if (val === 'custom') {
                this.showCustomCapital = true;
                return;
            }
            
            const capInfo = this.capList.find(x => x.value === val);
            //const displayText = capInfo.cap;
            const displayText = capInfo.start && capInfo.end ? `${capInfo.start}萬~${capInfo.end}萬` : capInfo.cap;

            // 先移除舊的資本額標籤
            this.capList.forEach(cap => {
                if (this.lstQuery.includes(cap.cap)) {
                    this.removeQueryCondition(cap.cap);
                }
            });
            console.log('radClick remove old capital condition:', this.queryConditions.capital);
            if( this.queryConditions.capital && this.queryConditions.capital.range ){
                // 移除結構化查詢條件
                this.removeQueryCondition(this.queryConditions.capital.range);
            }
            
            // 添加新的資本額條件
            this.addQueryCondition('capital', {
                start: capInfo.start,
                end: capInfo.end,
                range: displayText
            }, displayText);
            
            this.radCap = val;
        },
        
        // 確認自訂資本額區間
        confirmCustomCapital() {
            const start = parseFloat(this.customCapital.start);
            const end = parseFloat(this.customCapital.end);
            
            // 驗證輸入
            if (!start || !end) {
                notify({ type: 'warning', title: '警告', message: '請輸入完整的起始和結束金額' });
                return;
            }
            
            if (start >= end) {
                notify({ type: 'warning', title: '警告', message: '起始金額必須小於結束金額' });
                return;
            }
            
            // 移除舊的資本額標籤（包括預設選項和之前的自訂區間）
            this.capList.forEach(cap => {
                if (this.lstQuery.includes(cap.cap)) {
                    this.removeQueryCondition(cap.cap);
                }
            });
            
            // 移除之前的自訂區間標籤
            const customTags = this.lstQuery.filter(tag => tag.includes('萬~') && tag.includes('萬'));
            customTags.forEach(tag => {
                this.removeQueryCondition(tag);
            });
            
            // 建立顯示文字
            const displayText = `${start}萬~${end}萬`;
            
            // 添加新的資本額條件
            this.addQueryCondition('capital', {
                start: start,
                end: end,
                range: displayText
            }, displayText);
            
            // 清空輸入並關閉對話框
            this.customCapital.start = '';
            this.customCapital.end = '';
            this.showCustomCapital = false;
            
            notify({ type: 'success', title: '成功', message: `已設定資本額區間：${displayText}` });
        },
        
        // 更新設立日期處理
        yearClick(val) {
            // 如果選擇自訂區間，開啟對話框
            if (val === 'custom') {
                this.showCustomYear = true;
                return;
            }
            
            const yearInfo = this.yearList.find(x => x.value === val);
            const displayText = yearInfo.cap;
            
            // 計算實際的日期範圍
            const currentYear = new Date().getFullYear();
            const startYear = currentYear - yearInfo.end;
            const endYear = currentYear - yearInfo.start;
            
            const startDate = `${startYear}-01-01`;
            const endDate = `${endYear}-12-31`;
            
            console.log('設立日期計算:', {
                currentYear,
                yearInfo,
                startYear,
                endYear,
                startDate,
                endDate
            });
            
            // 先移除舊的設立日期標籤
            this.yearList.forEach(year => {
                if (this.lstQuery.includes(year.cap)) {
                    this.removeQueryCondition(year.cap);
                }
            });
            if( this.queryConditions.setupDate && this.queryConditions.setupDate.rangeValue=="custom" ){
                // 移除結構化查詢條件
                this.removeQueryCondition(this.queryConditions.setupDate.range);
            }
            
            // 添加新的設立日期條件
            this.addQueryCondition('setupDate', {
                range: displayText,
                start: startDate,
                end: endDate,
                rangeValue: val
            }, displayText);
            
            this.yearCap = val;
        },
        
        // 確認自訂設立日期區間
        confirmCustomYear() {
            const start = parseFloat(this.customYear.start);
            const end = parseFloat(this.customYear.end);
            
            // 驗證輸入
            if (!start || !end) {
                notify({ type: 'warning', title: '警告', message: '請輸入完整的起始和結束年限' });
                return;
            }
            
            if (start >= end) {
                notify({ type: 'warning', title: '警告', message: '起始年限必須小於結束年限' });
                return;
            }
            
            // 移除舊的設立日期標籤（包括預設選項和之前的自訂區間）
            this.yearList.forEach(year => {
                if (this.lstQuery.includes(year.cap)) {
                    this.removeQueryCondition(year.cap);
                }
            });
            
            // 移除之前的自訂區間標籤
            const customTags = this.lstQuery.filter(tag => tag.includes('年~') && tag.includes('年'));
            customTags.forEach(tag => {
                this.removeQueryCondition(tag);
            });
            
            // 建立顯示文字
            const displayText = `${start}年~${end}年`;
            
            // 計算實際的日期範圍
            const currentYear = new Date().getFullYear();
            const startYear = currentYear - end;
            const endYear = currentYear - start;
            const startDate = `${startYear}-01-01`;
            const endDate = `${endYear}-12-31`;
            
            // 添加新的設立日期條件
            this.addQueryCondition('setupDate', {
                range: displayText,
                start: startDate,
                end: endDate,
                rangeValue: 'custom'
            }, displayText);
            
            // 清空輸入並關閉對話框
            this.customYear.start = '';
            this.customYear.end = '';
            this.showCustomYear = false;
            
            notify({ type: 'success', title: '成功', message: `已設定設立日期區間：${displayText}` });
        },
        
        // 更新地區處理
        handleAreaChange(values) {
            console.log('父組件接收到區域變更：', values);
            
            if (!values || values.length === 0) {
                console.log(this.queryConditions);
                // 清除地點查詢條件
                if( this.queryConditions.location && Object.keys(this.queryConditions.location).length > 0 ) {
                    // 組合出顯示文字
                    const citydistict = this.queryConditions.location.city.trim() + this.queryConditions.location.district.trim();
                    console.log('移除地點查詢條件，標籤文字：', citydistict);
                    this.removeQueryCondition(citydistict);
                }
                // this.removeQueryCondition('location');
                return;
            }
            
            // 先移除之前的地點選擇標籤
            this.removePreviousLocationTags();
            
            let displayText = '';
            let locationValue = {};
            
            if (values.length === 1) {
                const area = values[0];
                displayText = area;
                locationValue = { area, city: '', district: '' };
            } else if (values.length === 2) {
                const city = values[1];
                displayText = city;
                locationValue = { area: values[0], city, district: '' };
            } else if (values.length === 3) {
                const city = values[1];
                const district = values[2];
                displayText = `${city}${district}`;
                locationValue = { area: values[0], city, district };
            }
            
            if (displayText !== '全部') {
                this.addQueryCondition('location', locationValue, displayText);
            }
        },
        
        // 更新行業代碼處理
        handleIndustryCodeChange(value, selectedItems) {
            if (!value || value.length === 0) {
                return;
            }
            
            // 確保 selectedItems 存在且為陣列
            if (!selectedItems || !Array.isArray(selectedItems) || selectedItems.length === 0) {
                console.warn('selectedItems 為空或無效');
                return;
            }
            
            selectedItems.forEach(item => {
                if (item && item.label) {
                    this.addQueryCondition('industryCode', value[3], item.label);
                }
            });
            
            this.selectedIndustryCode = [];
        },
        
        // 更新標籤關閉處理
        handleClose(tag) {
            this.removeQueryCondition(tag);
        },
        
        // 更新清空條件處理
        doClearTags() {
            this.selectedIndustryCode = [];
            this.clearAllQueryConditions();
            this.selectedAreaValue = [];
            
        },

        // 處理 input 清除按鈕事件
        handleClearInput() {
            // 從 queryConditionMap 中找到類型為 'keyword' 的條目
            for (let [displayText, mapping] of this.queryConditionMap) {
                if (mapping.type === 'keyword') {
                    this.removeQueryCondition(displayText);
                    break;
                }
            }
        },
        
        // 更新查詢方法，使用結構化資料
        async getList() {

          let qry = { 
            Page_Size: this.listQuery.Page_Size, 
            Page_Num: this.listQuery.Page_Num 
          };

          console.log('selectedAreaValue:', this.selectedAreaValue);
          // 處理地區條件
          if( this.selectedAreaValue && this.selectedAreaValue.length==2 ) {            
                qry.City = this.selectedAreaValue[1];
          }          
          if( this.selectedAreaValue && this.selectedAreaValue.length==3 ) {            
                qry.City = this.selectedAreaValue[1];            
                if( this.selectedAreaValue[2] && this.selectedAreaValue[2] !== '全部' )
                    qry.District = this.selectedAreaValue[2];
          }

        //   if (this.selectedCity && this.selectedCity !== '全部') {
        //     qry.City = this.selectedCity;
        //   }

        //   if (this.selectedDistrict && this.selectedDistrict !== '') {
        //     qry.District = this.selectedDistrict;
        //   }

          if( qry.City=='全部' )
              delete qry.City;
          

          // 處理關鍵詞查詢
          if (this.queryConditions.keyword?.length > 0) {
            // 先用空格切開查詢詞，支援多關鍵字查詢, 並轉成list 
            const querykeysList = this.queryConditions.keyword.trim().split(/\s+/);            
            qry.SearchText = querykeysList;
          }
          

          // 處理公司狀況
          if (this.queryConditions.companyStatus.length > 0) {
            if (this.queryConditions.companyStatus === '營業中') {
                qry.DataStatus = ['new','modify'];
            } else if (this.queryConditions.companyStatus === '非營業中') {
                qry.DataStatus = ['delete'];
            }
            // qry.DataStatus = [this.queryConditions.companyStatus];
          }
          // 處理公司類別
          if (this.queryConditions.companyType.length > 0) {
            qry.AuComType = this.queryConditions.companyType;
          }
          // 處理組織別
          if (this.queryConditions.orgType.length > 0) {
            qry.ComType = this.queryConditions.orgType;
          }
          // 處理即有客戶
          if (this.queryConditions.isCustomer) {
            qry.IsExistingCustomer = 'Y';
          }
          // 處理有發票
          if (this.queryConditions.isInvoice) {
            qry.HasInvoice = 'Y';
          }
          // 處理有進口
          if (this.queryConditions.isImport) {
            qry.HasImport = 'Y';
          }
          // 處理有出口
          if (this.queryConditions.isExport) {
            qry.HasExport = 'Y';
          }
          // 處理有工廠
          if (this.queryConditions.isFactory) {
            qry.HasFactory = 'Y';
          }
          // 處理資本額
          if (this.queryConditions.capital.range) {
            qry.CapMin = this.queryConditions.capital.start * 10000; // 以萬元為單位
            qry.CapMax = this.queryConditions.capital.end * 10000; // 以萬元為單位
          }
          // 處理設立日期
          if (this.queryConditions.setupDate.range) {
            qry.Start_Date = this.queryConditions.setupDate.start;
            qry.End_Date = this.queryConditions.setupDate.end;
          }
          // 處理行業代號
          if (this.queryConditions.industryCode && this.queryConditions.industryCode.length > 0) {
            qry.IndusNm = this.queryConditions.industryCode; // 目前只支援單一行業代號
          }

            // 處理精確標籤查詢
            if (this.queryConditions.preciseTags && this.queryConditions.preciseTags.length > 0) {
                qry.PreciseTags = this.queryConditions.preciseTags.map(tagItem => ({
                        category: tagItem.category,
                        display_name: tagItem.display_name || tagItem.name
                }));
            }

          // 處理經緯度範圍查詢
          if( this.queryConditions.geolocation) {
            if( this.queryConditions.geolocation.Distance.length >0 &&
                this.queryConditions.geolocation.Latitude &&
                this.queryConditions.geolocation.Longitude ) {
                
                qry.Distance = this.queryConditions.geolocation.Distance;
                qry.Latitude = this.queryConditions.geolocation.Latitude;
                qry.Longitude = this.queryConditions.geolocation.Longitude;
            }
          }

          // 處理location欄位
          if (this.queryConditions.location) {
            if (this.queryConditions.location.city && this.queryConditions.location.city !== '全部') {
                qry.City = this.queryConditions.location.city;
            }
            if (this.queryConditions.location.district && this.queryConditions.location.district !== '') {
                qry.District = this.queryConditions.location.district;
            }
          }

          // 處理comloc欄位
          if (this.queryConditions.comloc) {
            qry.ComLoc = this.queryConditions.comloc;
          }



            
            this.$store.dispatch("loadingHandler", true);
            
            try {
                console.log('查詢參數:', qry);
                const res = await this.$api.apies.search_bidmain(qry);
                
                this.tableData = res.data;

                // 依據回傳結果, 設定 tags_array
                this.tableData.forEach(item => {
                    item.tags_array = this.showTags(item);
                });

                this.totalLists = parseInt(res.total);
                console.log('查詢結果:', this.tableData);

            } catch (err) {
                handleError(err, '網路發生錯誤');
            } finally {
                this.$store.dispatch("loadingHandler", false);
            }
        },

        indusCodeClick() {
            console.log('行業代號:', this.industryCode);
            this.lstQuery.push(this.industryCode);
            this.indusCode = '';

            // 關閉下拉選單
            this.$refs.industryCodeDropdown.hide();
        },

        async loadProjectNameList() {
            if( this.btnAdvFuncVisible==false ) {
                console.log("btnAdvFuncVisible==false, 不載入專案名稱參數");
                this.ProjectNameList = [];
                return;
            }
                
            
            const qry = {
                "Page_Num": 1,
                "Page_Size": 20
                
            }        
            console.log("載入專案名稱參數",qry);    
            await this.$api.apipocxpj.pocxpj_search(qry).then(response => {
                console.log("專案名稱列表",response);
                this.ProjectNameList = response.data;
            }).catch(error => {
                notify({
                    title: "錯誤",
                    message: "獲取專案名稱失敗，請稍後再試",
                    type: "error"
                });                
            });
        },

        // 從 queryConditions 重建 lstQuery 和映射關係（用於編輯模式）
        rebuildFromQueryConditions(conditions) {
            // 清空現有狀態
            this.lstQuery = [];
            this.queryConditionMap.clear();
            
            if (!conditions) return;

            console.log('從 queryConditions 重建狀態，輸入條件:', conditions);
            
            // 關鍵字
            if (conditions.keyword) {
                this.lstQuery.push(conditions.keyword);
                this.queryConditionMap.set(conditions.keyword, { type: 'keyword', value: conditions.keyword });
                this.keyword = conditions.keyword;
            }
            
            // 公司狀況
            if (conditions.companyStatus) {
                this.lstQuery.push(conditions.companyStatus);
                this.queryConditionMap.set(conditions.companyStatus, { type: 'companyStatus', value: conditions.companyStatus });
            }
            
            // 公司類別（陣列）
            if (conditions.companyType && Array.isArray(conditions.companyType)) {
                conditions.companyType.forEach(type => {
                    this.lstQuery.push(type);
                    this.queryConditionMap.set(type, { type: 'companyType', value: type });
                });
            }
            
            // 組織別（陣列）
            if (conditions.orgType && Array.isArray(conditions.orgType)) {
                conditions.orgType.forEach(type => {
                    this.lstQuery.push(type);
                    this.queryConditionMap.set(type, { type: 'orgType', value: type });
                });
            }
            
            // 布林值條件
            if (conditions.isCustomer) {
                this.lstQuery.push('既有客戶');
                this.queryConditionMap.set('既有客戶', { type: 'isCustomer', value: true });
                this.IsCustomer = true;
            }
            
            if (conditions.isInvoice) {
                this.lstQuery.push('有發票');
                this.queryConditionMap.set('有發票', { type: 'isInvoice', value: true });
                this.IsInvoice = true;
            }
            
            if (conditions.isImport) {
                this.lstQuery.push('有進口');
                this.queryConditionMap.set('有進口', { type: 'isImport', value: true });
                this.IsImport = true;
            }
            
            if (conditions.isExport) {
                this.lstQuery.push('有出口');
                this.queryConditionMap.set('有出口', { type: 'isExport', value: true });
                this.IsExport = true;
            }
            
            if (conditions.isFactory) {
                this.lstQuery.push('有工廠');
                this.queryConditionMap.set('有工廠', { type: 'isFactory', value: true });
                this.IsFactory = true;
            }
            
            // 資本額
            if (conditions.capital && conditions.capital.range) {
                this.lstQuery.push(conditions.capital.range);
                this.queryConditionMap.set(conditions.capital.range, { 
                    type: 'capital', 
                    value: conditions.capital 
                });
            }
            
            // 設立日期
            if (conditions.setupDate && conditions.setupDate.range) {
                this.lstQuery.push(conditions.setupDate.range);
                this.queryConditionMap.set(conditions.setupDate.range, { 
                    type: 'setupDate', 
                    value: conditions.setupDate 
                });
            }
            
            // 行業代碼（陣列）
            if (conditions.industryCode && Array.isArray(conditions.industryCode)) {
                conditions.industryCode.forEach(code => {
                    this.lstQuery.push(code);
                    this.queryConditionMap.set(code, { type: 'industryCode', value: code });
                });
            }

            // 完整地址關鍵字
            if (conditions.comloc && typeof conditions.comloc === 'string' && conditions.comloc.trim()) {
                const comlocText = conditions.comloc.trim();
                this.lstQuery.push(comlocText);
                this.queryConditionMap.set(comlocText, { type: 'comloc', value: comlocText });
            }

            // 精確標籤（陣列）
            if (conditions.preciseTags && Array.isArray(conditions.preciseTags)) {
                conditions.preciseTags.forEach(tagItem => {
                    const displayName = tagItem?.display_name || tagItem?.name;
                    if (tagItem && tagItem.category && displayName) {
                        this.addQueryCondition('preciseTag', {
                            category: tagItem.category,
                            display_name: displayName
                        }, '', tagItem.category);
                    }
                });
            }
            
            // 地址
            if (conditions.location && (conditions.location.city || conditions.location.district)) {
                const locationText = `${conditions.location.city || ''}${conditions.location.district || ''}`;
                this.lstQuery.push(locationText);
                this.queryConditionMap.set(locationText, { type: 'location', value: conditions.location });
                // 同步<DistSelection>的選擇狀態
                console.log('重建地區選擇狀態:', conditions.location);
                const _area = conditions.location.area || '全部';
                const _city = conditions.location.city;
                const _dist = conditions.location.district;
                if (_dist) {
                    this.selectedAreaValue = [_area, _city, _dist];
                } else if (_city) {
                    this.selectedAreaValue = [_area, _city];
                } else {
                    this.selectedAreaValue = [_area];
                }
            }
            
            console.log('重建後的狀態:', {
                lstQuery: this.lstQuery,
                queryConditions: this.queryConditions,
                mapping: Array.from(this.queryConditionMap.entries())
            });
        },         

        async getBranchDist() {
            const { branchArea, branchCity, branchDist } = this.$store.state;
            
            // 只有當所有值都存在時才設置（避免 [null, null, null] 的情況）
            if (branchArea && branchCity) {
                if (branchDist) {
                    this.selectedAreaValue = [branchArea, branchCity, branchDist];
                } else {
                    this.selectedAreaValue = [branchArea, branchCity];
                }
                console.log("父組件 - 初始化選擇區域:", this.selectedAreaValue);
                
                // 等待子組件完成初始化
                await this.$nextTick();
                this.handleAreaChange(this.selectedAreaValue);
            }
        },   
        
        async getFunctions() {
            // 如果 RoleName 是 HE, HD, HC, HC1  時, 才會顯示出來==> newTagForm.type='hq'
            // 如果是DO, APA, AP 角色, 則 無儲存, 載入搜尋條件及新增標籤, 新增潛在客戶 功能
            this.userInfo = this.$store.state.userInfo;
            if( this.userInfo && this.userInfo.Role ) {
                const role = this.userInfo.Role[0].toLowerCase();
                console.log("使用者角色:", role);
                if(  role=='hd' || role=='hc'  ) {
                    this.newTagFormType='hq';
                }
                else {
                    this.newTagFormType='br';
                }
                console.log("newTagFormType:", this.newTagFormType);
                if( role=='do' || role=='apa' || role=='ap' ) {
                    this.btnAdvFuncVisible = false;            
                } else {
                    this.btnAdvFuncVisible = true;
                }
                
            }    
        },
        
        async getPreferences() {
            if( this.btnAdvFuncVisible==false ) {
                console.log("btnAdvFuncVisible==false, 不載入分行偏好設定");
                // 若不載入分行偏好設定, 則用所在地區, 
                this.getBranchDist();
                // 再加上"營業中"的預設條件
                this.addQueryCondition('companyStatus', '營業中', '營業中');
                return;
            }

            const funs = this.$store.getters.userInfo; 
            
            // 如果 DeptID='H77', 代表是總行(roleName 應該都是HD, HC), 將funs.DeptID 設為 999, 代表總行, 以讀取總行的偏好設定
            if (funs.DeptID === 'H77'|| funs.DeptID === '041' || funs.DeptID === 'H07') {
                funs.DeptID = 999;
            }

            // // 讀取 division_info_list
            const qry = {
                "Page_Num": 1,
                "Page_Size": 1,
                "DeptID": funs.DeptID,
                "isSys": true
            }        
            console.log("讀取偏好設定參數",qry);    
            await this.$api.apidivison.division_info_list(qry).then( res => {
                console.log("division_info_list",res);
                if( res.total == 1) {
                    // 讀取 Parameters 欄位，並解析成物件
                    const paramsStr = res.data[0].Parameters;
                    if( paramsStr )  {
                        const qc = JSON.parse(paramsStr);
                        this.queryConditions = qc; 
                        this.rebuildFromQueryConditions(qc);
                    }
                    else {
                        console.warn('division_info 偏好設定中沒有 Parameters 欄位');
                        // 若沒有 Parameters，則用所在地區, 
                        this.getBranchDist();
                        // 再加上"營業中"的預設條件
                        this.addQueryCondition('companyStatus', '營業中', '營業中');
                    }
                }                
            }).catch( err => {
                console.log(err);
            });            
        },
        
    },
  
  async mounted() {

        await this.loadIndustryCodeNameMap();

    this.getFunctions();

    // 載入熱門標籤
    this.loadHotTags();

    // 載入專案名稱選項
    this.loadProjectNameList(); 
    
    // 載入已儲存的搜尋條件
    await this.loadSaveSearchfromAPI();
    
    // 取得query string
    const rawKeyword = this.$route.query.keyword;
    let qKeyword = '';
    if (typeof rawKeyword === 'string') {
        try {
            qKeyword = decodeURIComponent(rawKeyword);
        } catch (e) {
            qKeyword = rawKeyword;
        }
    }
    const qCategory = this.$route.query.category;
    const qType = this.$route.query.type;
    const rawComloc = this.$route.query.comloc;
    let qComloc = '';
    if (typeof rawComloc === 'string') {
        try {
            qComloc = decodeURIComponent(rawComloc);
        } catch (e) {
            qComloc = rawComloc;
        }
    }
    if( qCategory &&  qKeyword && qType) {
        // 透過統一的 queryConditions + getList 流程處理精確標籤查詢
        this.clearAllQueryConditions();
        // 加工import_value, export_value, 原因是我在前端有加工文件,要拿掉才能正確搜尋到資料庫裡的標籤
        if( qCategory=='import_value' || qCategory=='export_value' ) {
            qKeyword = qKeyword.replace(/\s*進口\s*/g, '_').replace(/\s*出口\s*/g, '_').replace(/級/g, ''); 
        }


        this.addQueryCondition('preciseTag', {
            category: qCategory,
            display_name: qKeyword
        }, '', this.getPreciseTagTitle(qCategory));
        await this.getList();
        return; // 直接進行搜尋, 不要載入分行偏好設定
    }

    if (qComloc && qComloc.trim()) {
        this.clearAllQueryConditions();
        this.addQueryCondition('comloc', qComloc.trim(), qComloc.trim());
        await this.getList();
        return;
    }

    if( qKeyword) {
        this.listQuery.searchContent = qKeyword;
        this.keyword = qKeyword;
        this.lstQuery.push(qKeyword);
        // await this.getList(); 
    }   


    

    // 取得分公司偏好查詢條件, 若是空的, 則利用所在地區
    await this.getPreferences();             
    // 取得
    await this.getList();
  },
};
</script>

<style lang="scss" scoped>

//* {
//     outline: 1px solid red;    
//}

.CustBox {
    display: flex;
    flex-direction: row;
    padding: 10px 5%;
    outline: red 0px solid;
    .custom-tag {
        margin-right: 10px;
        width: auto;
    }
}



.indusCodeBox {
    display: flex;
    flex-direction: row;
    align-items: center; /* 改為居中對齊 */
    
    width: 100%; /* 改為100%寬度，讓容器自適應父元素 */    
    flex-wrap: wrap; /* 允許元素換行 */
    overflow-x: hidden; /* 隱藏水平捲軸 */

}

.iconItem {
    margin-right: 10px;
    width:100px;
    cursor: pointer;
}

.tagsClass{
    margin-right: 10px;
    border: 1px solid #ddd;
}


.el-dropdown {
    margin-right: 20px;
}


.comRelBox {
//   height:100vh;
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%) center center / 100% 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
//   padding: 0px 5%;

  .dialogBox {
    display: flex;
    flex-direction: column;    
    width:90%;
    padding: 5px 5%;
    .upperBox {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        margin-top:20px; 
        margin-bottom: 20px;

        label {
          width: 100px;
          white-space: nowrap;
          margin-right: 10px;
          text-align: right;
        }
    }

    .lowerBox {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        margin-top:20px; 
        margin-bottom: 20px;

        .el-radio-group {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
        }
        .el-radio-group .el-radio {
            flex: 0 0 25%;  /* 控制每行顯示四個選項 */
            margin-top: 10px;
        }
    }

  }

  .searchMain {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 0px 5%;
    .row1 {
      width:100%;      
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin-top:5px; 
        margin-bottom: 5px;

        .el-checkbox__label {
          white-space: nowrap;
          font-size: smaller;
            label {
                width: 100px;
                white-space: nowrap;
                margin-right: 10px;          
                font-size:smaller !important;
            }
        }
      }
    }
    .rowtag {
      width: 100%;      
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;       
      margin: 0.3rem 0; /* 3px/16px = 0.1875rem */     
      flex-wrap: wrap; /* 允許標籤換行 */

      label {       
        font-size: medium;   
        white-space: nowrap;                  
      }

      .el-button {
        margin-left: 0.5rem; /* 10px/16px = 0.5rem */
      }
      
       .el-tag {
        max-width: none !important; /* 強制移除最大寬度限制 */
        flex-shrink: 0; /* 防止標籤收縮 */
        width: auto !important; /* 強制自動寬度 */
        min-width: auto !important; /* 移除最小寬度限制 */
        margin-right: 0.5rem; /* 5px/16px = 0.5rem */
      }    

    }    
  }


  .searchWrap {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-start;
    padding: 0px 5%;

    
    .row1 {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;   
      margin: 5px 0px;
      
      
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;  
        margin-right: 20px;                
        
        label {       
          font-size: medium;   
          white-space: nowrap;          
          margin-right: 10px;
        }
      }
    }

    .row2 {
      height: 50px;
      width:100%;      
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin-top:20px; 
        margin-bottom: 20px;

        label {
          width: 100px;
          white-space: nowrap;
          margin-right: 10px;        
        }
      }        
    }

    .row3 {
      width:100%;      
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin-top:20px; 
        margin-bottom: 20px;

        label {
          width: 100px;
          white-space: nowrap;
          margin-right: 10px;
          text-align: right;
        }
      }
    }    

  }
  .content {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-start;
    padding: 0px 5%;
    .el-table {
        width: 100%;
        margin-top: 20px;
    }

  }
  .pageBox {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-end;
    padding: 0px 5%;
   }  

  .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
   }



}
</style>

<style>
/* 增加全局樣式，確保多選下拉框不折行 */
.flexible-select .el-tag {
  margin: 2px 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.flexible-select.el-select .el-select__tags {
  flex-wrap: nowrap;
  overflow-x: auto;
  max-width: 100%;
  padding-right: 30px; /* 為箭頭留出空間 */
  scrollbar-width: thin; /* Firefox */
}

/* 為 Webkit 瀏覽器設定滾動條樣式 */
.flexible-select.el-select .el-select__tags::-webkit-scrollbar {
  height: 4px;
}

.flexible-select.el-select .el-select__tags::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 2px;
}

/* 調整 dropdown 選單與觸發按鈕之間的間距 */
.el-dropdown-menu {
  margin-top: 5px !important;
}

/* 加深 checkbox 方框邊框顏色 */
.el-checkbox__inner {
  border-color: #606266 !important;
  border-width: 1.5px !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
}

/* 標籤表單樣式 */
.tag-form {
  padding: 1rem;
}

.form-item {
  margin-bottom: 1.5rem;
}

.form-item label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
  color: #606266;
}

.company-name {
  padding: 0.5rem;
  background-color: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background-color: #f5f7fa;
  border-radius: 4px;
  width: 100%;
}

.no-tags-message {
  text-align: center;
  padding: 2rem;
  color: #909399;
}

/* 標籤抽屜樣式 */
.tag-drawer-content {
  padding: 1rem;
  height: 100%;
  overflow-y: auto;
}

.company-info-section,
.tags-section {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #409EFF;
}

.section-title {
  margin: 0 0 1rem 0;
  color: #303133;
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-title i {
  color: #409EFF;
  font-size: 1.2rem;
}

.company-details {
  line-height: 1.6;
}

.company-details p {
  margin: 0.5rem 0;
  color: #606266;
}

.company-details strong {
  color: #303133;
  font-weight: 600;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: flex-start;
}

.tag-item {
  margin: 0;
  font-size: 0.875rem;
  padding: 0.25rem 0.75rem;
  border-radius: 16px;
  width: auto;
  min-width: auto;
  max-width: none;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
}

.no-tags {
  color: #909399;
  font-style: italic;
}

.tag-actions {
  position: sticky;
  bottom: 0;
  background-color: white;
  padding: 1rem 0;
  border-top: 1px solid #ebeef5;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.tag-actions .el-button {
  min-width: auto;
}

</style>



